export default {
  attendance: {
    additionalInformations: 'Dodatkowe informacje',
    attendanceTitle: 'Obecność',
    client: 'Rezerwujący',
    date: 'Data',
    exportAs: 'Eksportuj jako ',
    filePrefix: 'lista-obecnosci.',
    noReservations: 'Nie znaleziono żadnych rezerwacji...',
    noReservationsForGivenFilters: 'Nie znaleziono żadnych rezerwacji spełniających podane kryteria...',
    service: 'Usługa',
    status: 'Status rezerwacji',
    title: 'Lista obecności',
    worker: 'Pracownik'
  },
  attendanceListItem: {
    call: 'Zadzwoń',
    cardRegistered: 'Karta zarejestrowana',
    category: 'Kategoria: ',
    clientNotPresent: 'Klient nieobecny',
    clientPresentSaved: 'Zmieniono status na obecny',
    clientNotPresentSaved: 'Zmieniono status na nieobecny',
    clientPresentReset: 'Zresetowano status obecności',
    formSent: 'Formularz wysłano:',
    paid: 'Zapłacone',
    reservationDetails: 'Szczegóły rezerwacji #{id}',
    reservationParentDetails: 'Rezerwacja główna #{id}',
    seeMore: 'Zobacz więcej',
    sendEmail: 'Wyślij e-mail',
    unPaid: 'Niezapłacone'
  },
  app: {
    loadingChunkAlert: {
      title: 'Wystąpił błąd podczas wczytywania aplikacji',
      desc: 'Należy odświeżyć stronę. Niezapisane dane mogą zostać utracone.',
      btn: 'Odśwież'
    },
    pageTitle: 'System rezerwacji online Bookero',
    systemExpired: {
      title: 'System wygasł',
      desc: 'Dodawanie rezerwacji będzie niemożliwe do czasu opłacenia subskrypcji.'
    }
  },
  autoLogin: {
    loadingText: 'Trwa logowanie...'
  },
  blockedTerminListItem: {
    blockedCalendarForDays: 'Blokada wszystkich usług na dni',
    blockedCalendarForHours: 'Blokada wszystkich usług na godziny',
    blockedCalendarForServiceForDays: 'Blokada usługi na dni',
    blockedCalendarForServiceForHours: 'Blokada usługi na godziny',
    blockedCalendarForWorker: 'Blokada pracownika',
    blockedFromSearch: 'Blokada z wyszukiwarki terminów',
    blockedFromCart: 'Blokada z koszyka',
    blockedTo: 'Zablokowane do',
    category: 'Kategoria: ',
    call: 'Zadzwoń',
    date: 'Blokowany termin',
    dateRange: 'Termin',
    formSent: 'Data utworzenia:',
    reservationDetails: 'Szczegóły blokady #{id}',
    seeBlockedTerminDetails: 'Zobacz szczegóły blokady',
    sendEmail: 'Wyślij e-mail'
  },
  blockedTermins: {
    date: 'Blokowany termin',
    blockedTo: 'Koniec blokady',
    noBlockedTermins: 'Brak blokad terminów',
    noBlockedTerminsForGivenFilters: 'Brak blokad terminów spełniających podane kryteria',
    notes: 'Uwagi',
    onlyBlockedCalendarForDays: 'Tylko blokady wszystkich usług na dni',
    onlyBlockedCalendarForHours: 'Tylko blokady wszystkich usług na godziny',
    onlyBlockedCalendarForServiceForDays: 'Tylko blokady usług na dni',
    onlyBlockedCalendarForServiceForHours: 'Tylko blokady usług na godziny',
    onlyBlockedCalendarForWorker: 'Tylko blokady pracownika',
    onlyBlockedFromSearch: 'Tylko blokady z wyszukiwarki terminów',
    onlyBlockedFromCart: 'Tylko blokaday z koszyka',
    service: 'Usługa',
    title: 'Lista blokad terminów',
    type: 'Rodzaj blokady',
    worker: 'Pracownik'
  },
  billing: {
    addNewCard: 'Dodaj nową kartę',
    allPricesAreNet: 'Wszystkie podane ceny są cenami netto.',
    cardAutoPackage: 'Powiązany pakiet',
    cardAutoSms: 'Powiązany pakiet SMS',
    cardExpiryDate: 'Data wygaśnięcia',
    cardNumber: 'Numer karty',
    cardRemove: 'Usuń kartę',
    cardsTitle: 'Podpięte karty debetowe/kredytowe',
    changeToThisPackage: 'Przejdź na ten pakiet',
    changeYourPackage: 'Zmień swój pakiet',
    charge: 'Doładuj',
    currentPackage: 'Aktualna taryfa:',
    currencyPerMonth: ' / mc',
    days: 'dni',
    expired: 'System wygasł',
    expireDate: 'Wygasa:',
    expiresFor: 'za',
    expiresIn: 'System wygasa',
    expiresSoon: 'System wygasa niebawem',
    gross: 'Cena brutto',
    iChoose: 'Wybieram',
    invoicesTitle: 'Lista faktur',
    invoiceDate: 'Data wystawienia',
    invoiceDownload: 'Pobierz',
    invoiceNumber: 'Nr faktury',
    invoicePackage: 'Pakiet',
    invoiceQuote: 'Kwota',
    invoiceValidity: 'Ważność',
    isAboutToExpire: 'Wygasa niebawem',
    isExpired: 'Wygasła',
    itemCart: 'Koszyk rezerwacji',
    itemCalendarIntegrations: 'Integracja z kalendarzmi Google i Outlook',
    itemCustomers: 'Katalog klientów',
    itemCustomModifications: 'Możliwość zamówienia indywidualnych modułów systemu',
    itemCustomParams: 'Rozbudowa formularza o własne parametry',
    itemDailyReservations: 'Rezerwacje na dni',
    itemHoursTable: 'Tworzenie harmonogramu godzin otwarcia',
    itemFakturownia: 'Integracja z Fakturownia',
    itemMultilangugage: 'Wielojęzyczność',
    itemPayments: 'Płatności online<small>Możliwość podpięcia wielu systemów płatności</small>',
    itemPeriodicity: 'Cykliczność rezerwacji',
    itemPriceRulesAndDiscounts: 'Reguły cen i rabaty',
    itemReservationRules: 'Reguły rezerwacji <small>(Automatyczne rezerwacje)</small>',
    itemServices: 'Zarządzanie usługami',
    itemSMS: 'Powiadomienia SMS',
    itemSurveys: 'Ankiety',
    itemSystemReservation: 'System rezerwacji',
    itemQR: 'Generowanie biletów QR',
    itemWhiteLabeling: 'Ukryta stopka Bookero we wtyczkach',
    itemWorkers: 'Zarządzanie pracownikami',
    itemWorkersOneWorker: '(jeden pracownik jako konto administratora)',
    itemWorkersUpTo: '(do {maxWorkers} pracowników)',
    itemWorkesNoLimit: '(bez limitu)',
    itemWWW: 'Kreator strony www',
    lackOfCompanyData: 'Nie podano danych firmowych - faktura zostanie wystawiona na osobę fizyczną.',
    loadingCardsData: 'Wczytywanie danych kart',
    loadingCardsDataError: 'Wystąpił błąd podczas wczytywania danych kart.',
    month1: '1 miesiąc',
    month6: '6 miesięcy',
    month12: '12 miesięcy',
    noCardsToDisplay: 'Brak podpiętych kart',
    noInvoiceDataTitle: 'Brak danych do faktury',
    noInvoiceDataDesc: 'Proszę wypełnić dane firmy przed złożeniem zamówienia',
    noInvoiceDataCardDesc: 'Proszę wypełnić dane firmy przed dodaniem karty debetowej/kredytowej',
    noInvoiceDataBtn: 'Przejdź do ustawień',
    renewThisPackage: 'Przedłuż swój pakiet',
    renewThisPackageFor1Month: 'Przedłuż swój pakiet o 1 miesiąc',
    renewThisPackageFor6Months: 'Przedłuż swój pakiet o 6 miesięcy',
    renewThisPackageFor12Months: 'Przedłuż swój pakiet o 12 miesięcy',
    sms: 'SMS',
    smsLimit: 'Limit SMS:',
    smsPrice: 'gr / SMS',
    smsTitle: 'Wiadomości SMS',
    specialPrice: 'Cena tego pakietu jest indywidualna. Dziękujemy, że jesteś z nami!',
    title: 'Rozliczenia',
    youCanIncreaseSMSLimit: 'Możesz zwiększyć limit SMS wybierając jeden z pakietów po prawej.',
    yourCurrentPackage: 'Twój obecny pakiet',
    yourPlan: 'Twój plan',
    youSave: 'Oszczędzasz'
  },
  billingInvoiceItem: {
    date: 'Data wystawienia:',
    downloadInvoice: 'Pobierz fakturę',
    invoiceNumber: 'Numer faktury:',
    invoicePrefix: 'faktura-',
    package: 'Pakiet:',
    sms: 'SMS',
    smsPackage: 'Doładowanie SMS',
    quote: 'Kwota:',
    validity: 'Ważność:'
  },
  billingPopup: {
    addCreditCard: 'Podepnij kartę kredytową/debetową aby automatycznie opłacać odnowienia pakietów',
    basicPackageEnabled: 'Pakiet podstawowy został włączony',
    changePackage: 'Zmiana pakietu',
    expandPackage: 'Przedłużenie ważności pakietu',
    iamBuying: 'Zamawiam z obowiązkiem zapłaty',
    months: ' miesięcy',
    oneMonth: '1 miesiąc',
    packageDuration: 'Okres trwania:',
    paymentError: 'Wystąpił błąd podczas płatności kartą. Spróbuj ponownie.',
    paymentMethod: 'Metoda płatności:',
    paymentSuccess: 'Płatność kartą powiodła się.',
    payWithCard: 'Zapłać kartą {cardNumber}',
    payWithGateway: 'Zapłać poprzez bramkę płatności',
    priceWithTax: 'Cena z VAT:',
    processingCardPayment: 'Przetwarzanie płatności kartą...',
    redirectSoon: 'Za chwilę przekierujemy Cię do strony płatności...',
    selectedPackage: 'Wybrany pakiet:',
    selectedPaymentMethod: {
      gateway: 'bramka płatności Tpay',
      card: 'karta {cardNumber}'
    },
    selectPaymentMethod: 'Wybierz metodę płatności:',
    smsPackage: 'Doładowanie SMS',
    systemExpiresIn: 'System wygasa za {leftDays} dni'
  },
  blockDatePopup: {
    blockDate: 'Zablokuj termin',
    blockingDate: 'Blokowanie...',
    dateBlocked: 'Termin został zablokowany',
    email: 'Adres e-mail (opcjonalny):',
    errorDesc: 'Wystąpił błąd podczas tworzenia blokady terminu.',
    errorTitle: 'Wystąpił błąd',
    howLong: 'Na jak długo zablokować termin (w minutach):',
    name: 'Imię i nazwisko (opcjonalne):',
    phone: 'Numer telefonu (opcjonalny):',
    title: 'Zablokuj termin'
  },
  calendar: {
    addBlockade: 'Zablokuj kalendarz',
    day1: {
      short: 'Pn',
      long: 'Poniedziałek',
      shortPart1: 'Pon',
      shortPart2: 'iedziałek'
    },
    day2: {
      short: 'Wt',
      long: 'Wtorek',
      shortPart1: 'Wto',
      shortPart2: 'rek'
    },
    day3: {
      short: 'Śr',
      long: 'Środa',
      shortPart1: 'Śro',
      shortPart2: 'da'
    },
    day4: {
      short: 'Cz',
      long: 'Czwartek',
      shortPart1: 'Czw',
      shortPart2: 'artek'
    },
    day5: {
      short: 'Pt',
      long: 'Piątek',
      shortPart1: 'Pią',
      shortPart2: 'tek'
    },
    day6: {
      short: 'So',
      long: 'Sobota',
      shortPart1: 'Sob',
      shortPart2: 'ota'
    },
    day7: {
      short: 'Nd',
      long: 'Niedziela',
      shortPart1: 'Nie',
      shortPart2: 'dziela'
    },
    forDays: {
      collapseAll: 'Zwiń wszystkie',
      expandAll: 'Rozwiń wszystkie',
      servicesLabel: 'Nazwa usługi'
    },
    month1: {
      short: 'Sty',
      long: 'Styczeń',
      genitive: 'stycznia'
    },
    month2: {
      short: 'Lut',
      long: 'Luty',
      genitive: 'lutego'
    },
    month3: {
      short: 'Mar',
      long: 'Marzec',
      genitive: 'marca'
    },
    month4: {
      short: 'Kwi',
      long: 'Kwiecień',
      genitive: 'kwietnia'
    },
    month5: {
      short: 'Maj',
      long: 'Maj',
      genitive: 'maja'
    },
    month6: {
      short: 'Cze',
      long: 'Czerwiec',
      genitive: 'czerwca'
    },
    month7: {
      short: 'Lip',
      long: 'Lipiec',
      genitive: 'lipca'
    },
    month8: {
      short: 'Sie',
      long: 'Sierpień',
      genitive: 'sierpnia'
    },
    month9: {
      short: 'Wrz',
      long: 'Wrzesień',
      genitive: 'września'
    },
    month10: {
      short: 'Paź',
      long: 'Październik',
      genitive: 'października'
    },
    month11: {
      short: 'Lis',
      long: 'Listopad',
      genitive: 'listopada'
    },
    month12: {
      short: 'Gru',
      long: 'Grudzień',
      genitive: 'grudnia'
    },
    other: {
      at_hour: 'o godzinie',
      expandAllReservations: 'Rozwiń wszystkie rezerwacje',
      export_as: 'Eksportuj jako ',
      noReservationsForThisService: 'Brak rezerwacji',
      ongoingBlockadesOnHour: 'Blokady trwające o godzinie {hour}',
      ongoingReservationsOnHour: 'Rezerwacje trwające o godzinie {hour}',
      ongoingReservationsAndBlockadesOnHour: 'Rezerwacje i blokady trwające o godzinie {hour}',
      reservations: 'Rezerwacje',
      showOnlyReservations: 'ukryj wolne terminy',
      show_today: 'Pokaż dzisiaj',
      upcomingReservations: 'Nadchodzące rezerwacje',
      youCannotDisableThisOptionWhenFiltersAreActive: 'Gdy filtrowanie jest włączone, nie można wyłączyć tej opcji',
      youWantToAddReservation: 'Zamierzasz dodać rezerwację dnia {date} na godzinę {time}'
    }
  },
  calendarBlockadePopup: {
    blockadeAdded: 'Blokada dodana',
    blockadeAddErrorDesc: 'Wystąpił błąd podczas dodawania blokady. Spróbuj ponownie.',
    blockadeAddErrorTitle: 'Wystąpił błąd',
    blockingType: 'Typ blokady',
    blockingTypeCalendar: 'Blokada kalendarza',
    blockingTypeService: 'Blokada usługi',
    blockingTypeWorker: 'Blokada pracownika',
    description: 'Opis blokady',
    endDate: 'Koniec blokady',
    selectBlockingType: 'Wybierz typ blokady',
    selectService: 'Wybierz usługę',
    selectWorker: 'Wybierz pracownika',
    startDate: 'Początek blokady',
    title: 'Dodaj blokadę'
  },
  calendarDayPopupReservation: {
    cancelReservation: 'Anuluj rezerwację',
    cancelingReservationTitle: 'Anulowanie rezerwacji',
    cancelingReservationDesc: 'Wybrana rezerwacja jest cykliczna. Anulować tylko tę rezerwację, czy anulować ją razem z wszystkimi przyszłymi rezerwacjami z cyklu?',
    cancelingReservationCancelBtn: 'Anuluj wszystkie',
    cancelingReservationOkBtn: 'Anuluj tylko tę rezerwację',
    cancelingReservation2Title: 'Anulowanie rezerwacji',
    cancelingReservation2Desc: 'Czy chcesz anulować tę rezerwację?',
    cancelingReservation2Btn: 'Anuluj rezerwację',
    cardRegistered: 'Karta zarejestrowana',
    clientNotPresent: 'Klient się nie pojawił',
    clientNotPresentTitle: 'Klient nie przyszedł?',
    clientNotPresentDesc: 'Jeśli klient nie pojawił się, kliknij przycisk Tak, aby zanotować to w jego statystykach.',
    clientNotPresentBtn: 'Tak, klient się nie pojawił',
    clientNotPresentSaved: 'Zapisano nieobecność klienta',
    category: 'Kategoria: ',
    contactWithClient: 'Skontaktuj się z klientem',
    dateUnblocked: 'Wybrany termin został odblokowany',
    email: 'email:',
    getMoreInfoAboutReservation: 'Dowiedz się więcej o rezerwacji',
    getMoreInfoAboutBlockedDate: 'Dowiedz się więcej o blokadzie terminu',
    paid: 'Zapłacone',
    phone: 'tel:',
    reservationCancelled: 'Rezerwacja została anulowana',
    reservationCancelledNotificationsSent: 'Rezerwacja została anulowana, powiadomienia zostały wysłane',
    unblockDate: 'Odblokuj termin',
    unblockDateTitle: 'Odblokowanie terminu',
    unblockDateDesc: 'Wybrana blokada terminu jest cykliczna. Odblokować tylko ten termin, czy odblokować go razem z wszystkimi przyszłymi blokadami z cyklu?',
    unblockDateCancelBtn: 'Odblokuj wszystkie',
    unblockDateOkBtn: 'Odblokuj tylko ten termin',
    unblockDate2Title: 'Odblokowanie terminu',
    unblockDate2Desc: 'Czy chcesz odblokować ten termin?',
    unblockDate2Btn: 'Odblokuj termin',
    unpaid: 'Niezapłacone',
    waitingListTitle: 'Posiadasz listę rezerwową na wybrany termin',
    waitingListDesc: 'Czy powiadomić poniższe osoby o wolnym terminie?<br>',
    waitingListBtn: 'Tak, powiadom!'
  },
  calendarExportPopup: {
    anyPaymentStatus: 'Dowolny status płatności',
    dateSince: 'Data od:',
    dateTo: 'Data do:',
    downloadFile: 'Pobierz plik',
    downloadingFile: 'Pobieranie...',
    showContactData: 'Pokaż dane kontaktowe:',
    title: 'Eksport rezerwacji'
  },
  calendarWorkers: {
    checkTimetable: 'Sprawdź grafik',
    clickToHideWorkers: 'Kliknij aby ukryć pracowników',
    exportAs: 'Eksportuj jako ',
    isClosedWarning: '<strong>Uwaga!</strong> Tego dnia jest nieczynne.',
    someWorkersAreHidden: 'Ukrywanie pracowników jest włączone ({number})',
    title: 'Obłożenie pracowników',
    workerIsFree: 'Pracownik ma wolne',
    workerNotSupportThisService: 'nie wykonuje tej usługi',
    workerNotSupportThisServiceCategory: 'nie wykonuje tej kategorii usług',
    workerNotWorkInThisHours: 'Pracownik nie pracuje w tych godzinach'
  },
  calendarWorkersFiltersPopup: {
    hideWorkersWithoutReservation: 'Ukryj pracowników bez rezerwacji',
    noWorkersForGivenPhrase: 'Brak pracowników pasujących do podanej frazy',
    searchWorkersByName: 'Podaj nazwę pracownika',
    selectedWorkers: 'Wybranych pracowników: {count}',
    title: 'Konfiguracja ukrywania pracowników'
  },
  calendarView: {
    reservationsCalendar: 'Kalendarz rezerwacji',
    reservationsForDays: 'Rezerwacje na dni',
    title: 'Kalendarz rezerwacji',
    workersCalendar: 'Obłożenie pracowników'
  },
  changeDatePopup: {
    changeTerm: 'Zmień termin',
    changeReservationDate: 'Zmień datę rezerwacji <span> - wybierz termin</span>',
    clientNotificationTitle: 'Powiadomienie klienta',
    clientNotificationDesc: 'Czy chcesz powiadomić klienta mailem o dokonywanych zmianach?',
    clientNotificationBtnCancel: 'Nie powiadamiaj',
    clientNotificationBtnOk: 'Tak, powiadom',
    copyReservation: 'Kopiuj rezerwację',
    copyReservationTitle: 'Kopiuj rezerwację <span> - wybierz termin</span>',
    loadingTerms: 'Trwa ładowanie terminów...',
    reservationSucessfullyCopied: 'Rezerwacja została pomyślnie skopiowana',
    reservationTermChanged: 'Termin rezerwacji został zmieniony',
    select: 'Wybieram'
  },
  common: {
    block: {
      loadingData: 'Trwa ładowanie danych...',
      savingData: 'Trwa zapisywanie danych...'
    },
    invoiceDownloader: {
      generateInvoice: 'Wystaw fakturę',
      generatingInvoice: 'Trwa wystawianie faktury...',
      downloadInvoice: 'Faktura #{invoiceNumber}',
      downloadingInvoice: 'Trwa pobieranie faktury...',
      generateReceipt: 'Wystaw paragon',
      generatingReceipt: 'Trwa wystawianie paragonu...',
      downloadReceipt: 'Paragon #{receiptNumber}',
      downloadingReceipt: 'Trwa pobieranie paragonu...',
      filenameInvoice: 'faktura-{invoiceNumber}.pdf',
      filenameReceipt: 'paragon-{receiptNumber}.pdf',
      successMessageInvoice: 'Faktura o numerze #{externalInvoiceNumber} została wygenerowana.',
      successMessageReceipt: 'Paragon o numerze #{externalReceiptNumber} został wygenerowany.',
      errorMessageTitleInvoice: 'Generowanie faktury nie powiodło się',
      errorMessageTitleReceipt: 'Generowanie paragonu nie powiodło się',
      errorMessageDesc: 'Spróbuj ponownie lub sprawdź ustawienia integracji z API Fakturownia.'
    },
    mailSmsLegendText: {
      desc1: 'Dostępne wstawki do wykorzystania w treści:',
      desc2: 'Wstawia ID rezerwacji poprzedzone znakiem "#"',
      desc3: 'Wstawia datę terminu rezerwacji',
      desc4: 'Wstawia godzinę terminu rezerwacji',
      desc5: 'Wstawia wybraną usługę',
      desc6: 'Wstawia nazwę kategorii wybranej usługi',
      desc7: 'Wstawia imię i nazwisko pracownika wykonującego usługę',
      desc8: 'Wstawia adres e-mail pracownika wykonującego usługę',
      desc9: 'Wstawia link do spotkania na Google Meet',
      desc10: 'Wstawia nazwę etykiety dla terminu usługi'
    },
    pagination: {
      infoCounts: 'Wyświetlanie: rekordy {from}-{to} z {total} znalezionych.',
      infoCountsEmpty: 'Wyświetlanie: brak rekordów do wyświetlenia',
      activeFilters: 'Filtrowanie jest aktywne.',
      page: 'Strona',
      from: 'z {max}'
    },
    toggleAll: {
      label: 'Zaznacz / odznacz wszystkie'
    },
    ui: {
      add: 'Dodaj',
      addReservation: 'Dodaj rezerwację',
      addingReservation: 'Dodawanie rezerwacji',
      allBlockedTerminTypes: 'Pokazuj wszystkie blokady',
      allReservationTypes: 'Pokazuj wszystkie rezerwacje',
      allServices: 'Wszystkie usługi',
      allWorkers: 'Wszyscy pracownicy',
      and: ' i ',
      back: 'Wróć',
      blockedDatesNumber: 'Liczba blokad',
      cancel: 'Anuluj',
      childrenNumber: 'Liczba dzieci',
      clearFilters: 'Wyczyść filtry',
      clientInfo: 'Informacje o kliencie',
      close: 'Zamknij',
      closeNotNotify: 'Zamknij, nie powiadmiaj',
      closed: 'Nieczynne',
      closedNoCap: 'nieczynne',
      copied: 'Skopiowano',
      copy: 'Skopiuj',
      copyToClipboard: 'Skopiuj do schowka',
      cost: 'Koszt: ',
      creationDate: 'Używaj daty utworzenia rezerwacji',
      currentLanguage: 'pl',
      cycle: 'Cykl:',
      dailyBlockedTermins: 'Pokazuj tylko blokady na dni',
      dailyReservations: 'Pokazuj tylko rezerwacje na dni',
      datepickerFormat: 'MMM d, yyyy',
      datepickerFormatShort: 'MMM d',
      datepickerLanguage: 'pl',
      day: 'dzień',
      days: 'dni',
      daysNumber: 'Liczba dni',
      nightsNumber: 'Liczba dób',
      delete: 'Usuń',
      edit: 'Edytuj',
      elementNotExists: 'Wybrany element nie istnieje',
      emailPrefix: 'email:',
      for: 'na',
      free: 'Wolne',
      freeNoCap: 'wolne',
      freeOrServiceUnavailable: 'wolne lub usługa niedostępna',
      freeWork: 'Wolne od pracy',
      fullCycleCost: 'Koszt cyklu: ',
      hide: 'Ukryj',
      hideDetails: 'Ukryj szczegóły',
      hideViewOptions: 'Ukryj opcje widoku',
      hourlyBlockedTermins: 'Pokazuj tylko blokady na godziny',
      hourlyReservations: 'Pokazuj tylko rezerwacje na godziny',
      hoursShortcut: 'h',
      incomeCurrency: ' PLN',
      invalidFields: 'Niektóre pola są wypełnione niepoprawnie',
      loading: 'Ładowanie...',
      loadingData: 'Trwa ładowanie danych...',
      loadingError: 'Wystąpił błąd podczas wczytywania danych',
      loadMoreResults: 'Wczytaj więcej wyników',
      minutesShortcut: 'min',
      no: 'Nie',
      none: 'Brak',
      noPayment: 'Bez płatności',
      noReservations: 'Brak rezerwacji...',
      noReservationsForGivenFilters: 'Brak rezerwacji spełniających podane kryteria...',
      ok: 'OK',
      ongoing: 'trwających',
      paymentDate: 'Użyj daty płatności',
      paymentStatus: 'Status płatności',
      paid: 'Opłacone',
      paidWithCash: 'Płatność gotówką',
      peopleNumber: 'Liczba osób',
      phonePrefix: 'tel.',
      phoneNumberPrefix: '48',
      publish: 'Opublikuj',
      reservation: {
        term: 'Termin rezerwacji',
        date: 'Data rezerwacji',
        dateAs: 'Data rezerwacji jako',
        dateRange: 'Rezerwacja',
        preferredPeopleCount: 'Preferowana liczba osób',
        selectTermRequired: 'Musisz wybrać termin rezerwacji'
      },
      reservationDate: 'Używaj daty rezerwacji',
      reservationsNumber: 'Liczba rezerwacji',
      save: 'Zapisz',
      saveAllChanges: 'Zapisz wszystkie zmiany',
      saveChanges: 'Zapisz zmiany',
      search: 'Wyszukaj...',
      seeReservationDetails: 'Zobacz szczegóły rezerwacji',
      selectService: 'Wybierz usługę',
      service: 'Usługa:',
      services: {
        servicesWithoutCategory: 'Usługi bez kategorii'
      },
      show: 'Pokaż',
      showViewOptions: 'Pokaż opcje widoku',
      thisFieldIsRequired: 'To pole jest wymagane',
      to: 'do ',
      today: 'Dzisiaj',
      transactionID: 'Identyfikator płatności',
      unpaid: 'Nieopłacone',
      worker: 'Pracownik:',
      variations: {
        blockedDate: {
          single: 'blokada',
          plural1: 'blokady',
          plural2: 'blokad'
        },
        person: {
          single: 'osoba',
          plural1: 'osoby',
          plural2: 'osób'
        },
        reservation: {
          single: 'rezerwacja',
          plural1: 'rezerwacje',
          plural2: 'rezerwacji'
        },
        currentBlockedDate: {
          single: 'trwająca blokada',
          plural1: 'trwające blokady',
          plural2: 'trwających blokad'
        },
        currentReservation: {
          single: 'trwająca rezerwacja',
          plural1: 'trwające rezerwacje',
          plural2: 'trwających rezerwacji'
        },
        pastReservation: {
          single: 'odbyła się',
          plural1: 'odbyły się',
          plural2: 'odbyło się'
        }
      },
      yes: 'Tak',
      yesRemove: 'Tak, usuń'
    },
    workHours: {
      workingHours: 'Godziny pracy:'
    }
  },
  companyForm: {
    address: 'Adres:',
    applyVatID: 'Uzupełnij dane',
    city: 'Miejscowość:',
    companyCountry: 'Kraj:',
    companyData: 'Dane firmy',
    companyDataSaved: 'Dane firmy zostały zapisane',
    companyName: 'Nazwa firmy:',
    email: 'E-mail:',
    emailIsInvalid: 'Ten adres e-mail jest niepoprawny',
    emailIsTaken: 'Ten adres e-mail jest już używany. Spróbuj innego adresu.',
    fillThisFieldToChangePassword: 'Wypełnij to pole, jeśli chcesz zmienić hasło',
    invalidFileFormat: 'Niedozwolony format pliku.',
    invalidVATID: 'Nieprawidłowy NIP',
    invalidVATIDDesc: 'NIP musi się składać z 10 cyfr bez spacji i myślników.',
    invalidVATID2Desc: 'Nie znaleziono danych dla podanego numeru nip. Sprawdź podany numer NIP i spróbuj ponownie.',
    iWantInvoice: 'Chcę otrzymać fakturę VAT na firmę:',
    logo: 'Logo:',
    logoTitle: 'Logo',
    name: 'Imię i nazwisko:',
    nipRule: 'NIP musi się składać z 10 cyfr bez spacji i myślników.',
    openingHours: 'Godziny otwarcia',
    password: 'Hasło:',
    passwordConfirmation: 'Potwierdź hasło:',
    phone: 'Telefon:',
    postalCode: 'Kod pocztowy:',
    receiveNotifications: 'Wysyłaj informacje o rezerwacjach:',
    receiveNotificationsDesc: 'Gdy ta opcja jest włączona, informacje o rezerwacjach będą wysyłane na podany wyżej adres e-mail.',
    removeLogo: 'Usuń logo',
    selectCountry: '-- Wybierz kraj --',
    selectRegion: '-- Wybierz region --',
    submitNewFileToChangeLogo: 'Wyślij nowy plik by zmienić logo',
    supportedFormats: 'Obsługiwane formaty plików: JPG, PNG.',
    taxID: 'NIP:',
    thisEmailWillBeUsedToGetNotificationsAboutNewReservations: 'Ten adres e-mail będzie wykorzystywany do otrzymywania powiadomień o nowych rezerwacjach',
    thisEmailWillBeUsedToLogin: 'Ten adres e-mail będzie wykorzystywany do logowania się do panelu',
    timezone: 'Strefa czasowa',
    userData: 'Dane użytkownika',
    vatIDCheckInProgress: 'Weryfikuję...',
    www: 'Strona WWW:',
    wwwDescription: 'Jest to adres strony na którą przekierowywany jest klient po anulowaniu rezerwacji.<br>Adres ten powinien zaczynać się od "http://" lub "https://"'
  },
  cookieBanner: {
    text: 'Nasz serwis wykorzystuje pliki cookies. Korzystając z serwisu Użytkownik zgadza się na ich zapis lub wykorzystanie.'
  },
  creditCardItem: {
    cardHasBeenRemoved: 'Pomyślnie usunięto kartę',
    cardHasNotBeenRemovedProperly: 'Usunięcie karty nie powiodło się - spróbuj ponownie',
    confirmCardRemoveDesc: 'Usunięcie karty uniemożliwi automatyczne odnowienie usług powiązanych z nią, jeśli jest to jedyna karta przypisana do tych usług.',
    confirmCardRemoveTitle: 'Czy chcesz usunąć wybraną kartę?',
    noAutoPackage: 'Brak',
    noAutoSmsPackage: 'Brak',
    removeCard: 'Usuń kartę'
  },
  creditCardPopup: {
    addCard: 'Dodaj kartę',
    autoPackage: 'Odnawiaj automatycznie pakiet',
    autoSMS: 'Odnawiaj automatycznie pakiety SMS',
    autoSMSNumber: 'Liczba SMS kupowana przy odnowieniu',
    cardCvc: 'Kod CVC:',
    cardExpiryDate: 'Data ważności karty:',
    cardHasBeenAdded: 'Karta została pomyślnie dodana',
    cardHasNotBeenAdded: 'Nie udało się dodać karty',
    cardNumber: 'Numer karty:',
    disclaimer: 'Dane Twojej karty będą przetwarzany przez system płatności Stripe. Bookero nie będzie przechowywało danych Twojej karty.',
    errors: {
      cardDate: 'Wprowadź prawidłową datę',
      cardNumber: 'Wprowadź prawidłowy numer karty',
      cvc: 'Podaj kod CVC',
      package: 'Wybierz pakiet',
      smsNumber: 'Wybierz pakiet SMS'
    },
    packageChangeInfo: 'Uwaga! przy najbliższym odnowieniu Twoje konto zostanie zmienione z pakietu {currentPackage} na pakiet {selectedPackage}.',
    selectAutoPackage: 'Wybierz pakiet',
    selectPackage: 'Wybierz pakiet',
    selectSmsNumber: 'Wybierz pakiet SMS',
    title: 'Dodaj nową kartę'
  },
  customerAutocomplete: {
    email: 'E-mail:',
    name: 'Imię i nazwisko',
    noResults: 'Brak rezultatów...',
    phone: 'Telefon:'
  },
  customerFormPopup: {
    addClient: 'Dodaj klienta',
    email: 'E-mail:',
    emailIsInUse: 'Podany adres e-mail jest już używany przez innego klienta',
    emailIsRequired: 'Adres e-mail jest wymagany',
    invalidEmail: 'Nieprawidłowy adres e-mail',
    mobilePhone: 'Telefon komórkowy:',
    mobilePhoneIsInvalid: 'Podany numer telefonu jest niepoprawny',
    mobilePhoneIsInUse: 'Podany numer telefonu jest już używany przez innego klienta',
    mobilePhoneIsRequired: 'Wymagany jest prawidłowy numer telefonu',
    name: 'Imię i nazwisko:',
    nameIsRequired: 'Imię i nazwisko jest wymagane',
    titleAdd: 'Dodawanie klienta',
    titleEdit: 'Edycja klienta'
  },
  customerNote: {
    remove: 'Usuń notatkę',
    removed: 'Wybrana notatka została usunięta'
  },
  customerNotePopup: {
    addNote: 'Dodaj notatkę',
    content: 'Treść notatki:',
    contentIsRequired: 'Treść notatki jest wymagana',
    titleAdd: 'Dodawanie notatki klienta',
    titleEdit: 'Edycja notatki klienta'
  },
  customerPopup: {
    accepted: 'Zaakceptowane',
    acceptedTosAndPrivacyPolicy: 'Zaakceptowany regulamin i polityka prywatności:',
    addNewNote: 'Dodaj nową notatkę',
    agreementForEmail: 'Zgoda na działania marketingowe poprzez e-mail:',
    agreementForPhone: 'Zgoda na działania marketingowe poprzez połączenia telefoniczne:',
    contactData: 'Dane kontaktowe:',
    customerAgreements: 'Wyrażone zgody',
    customerStats: 'Statystyki klienta:',
    filterReservations: 'Filtruj rezerwacje',
    goToDate: 'Idź do daty',
    lastChanged: 'ostatnia zmiana:',
    no: 'Nie',
    noData: 'Brak danych',
    noNotes: 'Brak notatek...',
    notesAboutClient: 'Notatki o kliencie:',
    removeClient: 'Usuń klienta',
    removingCustomerTitle: 'Usuwanie klienta',
    removingCustomerDesc: 'Czy na pewno chcesz usunąć wybranego klienta?',
    removingCustomerBtn: 'Usuń klienta',
    reservations: 'Rezerwacje',
    reservationsHistory: 'Historia rezerwacji klienta:',
    reservationsInTheLastMonth: 'Rezerwacji w ostatnim miesiącu:',
    selectedClientRemoved: 'Wybrany klient został usunięty',
    totalIncome: 'Cały przychód:',
    totalPercent: 'Procent całości:',
    unableToLoadCustomer: 'Błąd wczytywania danych',
    unableToLoadCustomerDesc: 'Nie udało się wczytać danych klienta.',
    yes: 'Tak'
  },
  customerReservation: {
    accepted: 'Zaakceptowana',
    cardRegistered: 'Karta zarejestrowana',
    cancelled: 'Anulowana',
    clientNotPresent: 'Klient nieobecny',
    clientPresent: 'Klient obecny',
    hour: 'Godz:',
    no: 'NIE',
    paid: 'Zapłacone',
    presence: 'Obecność:',
    price: 'Cena:',
    rejected: 'Odrzucona',
    status: 'Status:',
    unpaid: 'Niezapłacone',
    yes: 'TAK',
    waitingList: 'Lista rezerwowa',
    waitsForAccept: 'Oczekuje na akceptację',
    waitsForPayment: 'Oczekuje na płatność'
  },
  customers: {
    addClient: 'Dodaj klienta',
    email: 'E-mail',
    exportAs: 'Eksportuj jako ',
    income: 'Dochód',
    name: 'Imię i nazwisko',
    noClientsFound: 'Nie znaleziono żadnych klientów...',
    phone: 'Telefon',
    searchInClients: 'Szukaj wśród klientów...',
    title: 'Klienci',
    youHaveABaseOfClients: 'Posiadasz bazę {totalCustomers} klientów'
  },
  customersListItem: {
    email: 'E-mail:',
    emailTooltip: 'email:',
    income: 'Dochód:',
    informations: 'Informacje',
    name: 'Imię i nazwisko:',
    noData: 'Brak danych',
    phone: 'Telefon:',
    phoneTooltip: 'tel:',
    removeAllReservationsWithCustomer: 'Usuń wszystkie rezerwacje klienta wraz z klientem ({count})',
    removeClient: 'Usuń klienta',
    removingClientTitle: 'Usuwanie klienta',
    removingClientDesc: 'Czy na pewno chcesz usunąć wybranego klienta?',
    removingClientBtn: 'Usuń klienta',
    selectedClientRemoved: 'Wybrany klient został usunięty'
  },
  dashboard: {
    buySmsPackage: 'Kup pakiet SMS',
    buySubscription: 'Wykup subskrypcję',
    clickToEnableReservations: 'Kliknij aby zmienić ustawienia',
    clickToRenew: 'Kliknij aby odnowić pakiet',
    confirmEmailAddress: 'Potwierdź swój adres e-mail, aby móc w pełni korzystać z funkcji Bookero.',
    confirmEmailAddressWorker: 'Potwierdź swój adres e-mail.',
    confirmationSend: 'Wysłano mail potwierdzający adres e-mail. Sprawdź swoją skrzynkę pocztową.',
    connectGoogleCalendar: 'Połącz konto z kalendarzem Google',
    connectOutlookCalendar: 'Połącz konto z kalendarzem Outlook',
    day: ' dzień',
    days: ' dni',
    daysReservations: 'Rezerwacje na dni',
    dayPlan: 'Plan dnia',
    googleCalendarActiveNoConnectedCalendar: 'Integracja z Google Calendar jest włączona, ale nie określono konta powiązanego z kalendarzami.',
    loadingWaitingRequests: 'Trwa ładowanie oczekujących rezerwacji...',
    noWaitingRequests: 'Obecnie nie masz żadnych oczekujących rezerwacji',
    outlookCalendarActiveNoConnectedCalendar: 'Integracja z Outlook Calendar jest włączona, ale nie określono konta powiązanego z kalendarzami.',
    paymentsEnabledNoPaymentMethod: 'Płatności są włączone, ale nie zdefiniowano żadnej metody płatności.',
    pluginReservationsDisabled: 'Uwaga! Dodawanie rezerwacji poprzez wtyczkę jest wyłączone.',
    resendConfirmation: 'Wyślij mail weryfikujący ponownie',
    resendSending: 'Wysyłanie...',
    servicesEnabledNoActiveService: 'Nie posiadasz żadnej aktywnej usługi, pomimo włączonej funkcji usług.',
    servicesWithoutWorkers: 'Posiadasz usługi bez przypisanych pracowników.',
    smsActiveNoSmsToSend: 'Powiadomienia SMS są aktywne jednak Twoja pula SMS została wyczerpana.',
    showAll: 'Pokaż wszystkie',
    showLess: 'Pokaż mniej',
    todaysReservations: 'Rezerwacje na dziś',
    toUseBookero: 'aby móc korzystać z wszystkich funkcji Bookero.',
    yourAccountExpired: 'Twoje konto wygasło.',
    yourPackageExpiresIn: 'Twój pakiet wygasa za ',
    yourPanel: 'Twój panel zarządzania rezerwacjami',
    upcomingWeekReservations: 'Rezerwacje na najbliższy tydzień',
    updateData: 'Odśwież',
    updatingData: 'Odświeżanie...',
    updateRequired: 'Pojawiły się zmiany w rezerwacjach - kliknij "Odśwież" aby wczytać zaktualizowane dane:',
    warning: 'Uwaga!',
    waitingRequests: 'Zapytania oczekujące',
    waitsForAccept: 'czeka na akceptację',
    workersWithoutServices: 'Posiadasz pracowników bez przypisanych usług.'
  },
  dashboardReservations: {
    daysReservationsStarts: 'Rozpoczynające się dziś rezerwacje',
    daysReservationsEnds: 'Kończące się dziś rezerwacje',
    loadingReservations: 'Trwa ładowanie rezerwacji...',
    noEndingReservations: 'Brak kończących się dziś rezerwacji...',
    noEndingReservationsForGivenFilters: 'Brak kończących się dziś rezerwacji spełniających podane kryteria...',
    noStartingReservations: 'Brak rozpoczynających się dziś rezerwacji...',
    noStartingReservationsForGivenFilters: 'Brak rozpoczynających się dziś rezerwacji spełniających podane kryteria...',
    noUpcomingReservations: 'Brak nadchodzących rezerwacji...',
    noUpcomingReservationsForDays: 'Brak rezerwacji na dziś...',
    noUpcoimngReservationsForGivenFilters: 'Brak nadchodzących rezerwacji spełniających podane kryteria...',
    reservationsForUpcomingWeek: 'Rezerwacje na najbliższy tydzień',
    searchClients: 'Wyszukaj klientów...',
    selectDay: 'Wybierz dzień',
    show: '(pokaż)',
    showOnlyUpcomingReservations: 'Pokazuj tylko przyszłe rezerwacje',
    todaysReservations: 'Rezerwacje na dziś',
    tookPlace: 'Dziś {tookPlace} już {count} {reservationWord}'
  },
  dashboardTodayTimeline: {
    allWorkersAreFreeToday: 'Wszyscy pracownicy mają dziś wolne...',
    checkTimetables: 'Sprawdź grafik',
    now: 'Teraz',
    workerIsFree: 'Pracownik ma wolne',
    workerNotWorksInThisHours: 'Pracownik nie pracuje w tych godzinach'
  },
  day: {
    from: 'Od:',
    to: 'Do:'
  },
  discounts: {
    addNew: 'Dodaj nowy rabat',
    couponsCount: 'Liczba kodów',
    emptyState: 'Brak zdefiniowanych rabatów...',
    loadingState: 'Trwa ładowanie danych...',
    name: 'Nazwa rabatu',
    params: 'Parametry',
    title: 'Kody rabatowe'
  },
  discountCodeFormPopup: {
    codesCount: 'Liczba kodów do wygenerowania:',
    generateCodes: 'Generuj kody rabatowe',
    provideCodesCount: 'Podaj liczbę kodów',
    title: 'Generowanie kodów rabatowych'
  },
  discountCodeListItem: {
    discountCode: 'Kod rabatowy:',
    removeDiscountCode: 'Usuń kod rabatowy',
    selectedCodeHasBeenRemoved: 'Wybrany kod rabatowy został usunięty',
    usedCount: 'Liczba użyć:'
  },
  discountsListItem: {
    countOfCodes: 'Liczba kodów:',
    dayOfReservation: 'Dzień na jaki jest składana rezerwacja',
    dayOfReservationSent: 'Dzień złożenia rezerwacji',
    dependsFromDate: 'Zależne od daty rezerwacji:',
    discount: 'Rabat:',
    discountName: 'Nazwa rabatu:',
    editDiscount: 'Edytuj rabat',
    limitOfUse: 'Limit wykorzystań kodu:',
    params: 'Parametry:',
    removeDiscount: 'Usuń rabat',
    removeDiscountTitle: 'Usuwanie rabatu',
    removeDiscountDesc: 'Czy na pewno chcesz usunąć wybrany rabat?',
    removeDiscountBtn: 'Usuń rabat',
    reservationHour: 'Zależne od godziny rezerwacji:',
    selectedDiscountRemoved: 'Wybrany rabat został usunięty',
    services: 'Usługi:'
  },
  discountsForm: {
    addTitle: 'Dodawanie rabatu',
    atLeastOneServiceIsRequired: 'Przynajmniej jedna usługa jest wymagana',
    codeExample: 'np. KOD_%C_%N',
    codeLimits: 'Limit wykorzystań kodu:',
    codeMask: 'Maska kodów:',
    codeMaskDescription: '%C - losowy znak [A-Z], %N - losowa liczba [0-9], przykładowy kod: KOD_%C_%N',
    dateRange: 'Zakres dat:',
    dependsFromHour: 'Zależne od godziny rezerwacji:',
    dependsFromReservationDate: 'Zależy od daty rezerwacji:',
    discountAdded: 'Rabat został dodany',
    discountCode: 'Kod rabatowy',
    discountCodes: 'Kody rabatowe',
    discountConfigurationChanged: 'Konfiguracja rabatu została zmieniona',
    discountInPercents: 'Rabat w %:',
    discountParams: 'Parametry rabatu',
    editTitle: 'Edycja rabatu',
    emptyState: 'Brak kodów rabatowych',
    generateNewCodes: 'Wygeneruj kody rabatowe',
    hoursRange: 'Zakres godzin:',
    limitedCode: 'Kod limitowany:',
    name: 'Nazwa rabatu:',
    numberOfUses: 'Liczba użyć',
    reservationDay: 'Dzień na jaki jest składana rezerwacja',
    reservationDaySubmit: 'Dzień złożenia rezerwacji',
    servicesTitle: 'Usługi',
    toGenerateDiscountCodesSaveADiscount: 'Aby wygenerować kody rabatowe z użyciem nowej maski kodów, musisz najpierw zapisać rabat.',
    youCanGenerateNewCodesAfterSavingADiscount: 'Generowanie kodów rabatowych będzie dostępne po zapisaniu rabatu.'
  },
  emailPreview: {
    accepted: 'Zaakceptowano',
    cancelled: 'Anulowano',
    cartStatusUpdated: 'Status koszyka rezerwacji został zaktualizowany',
    exampleService: 'Przykładowa usługa do wyboru',
    paid: 'Opłacono',
    reserveTermsList: 'Lista rezerwowanych terminów:',
    waitingList: 'Zapisano do listy rezerwowej',
    worker: 'Pracownik:',
    workerExample: 'Pracownik Pracujący'
  },
  errors: {
    allWorkersAndServicesWithIntegrationEnabled: {
      title: 'Brakujące powiązania kalendarzy',
      desc: 'Aby móc zapisać ustawienia, należy wszystkim pracownikom oraz usługom z włączoną integracją wybrać powiązany kalendarz.'
    },
    loadError: {
      title: 'Błąd podczas wczytywania danych',
      desc: 'Podczas wczytywania danych wystąpił błąd. Odśwież stronę aby spróbować ponownie.',
      refresh: 'Odśwież stronę'
    },
    operationError: {
      title: 'Operacja nie powiodła się',
      desc: 'Wybrana operacja nie powiodła się. Czy chcesz spróbować ponownie?',
      repeat: 'Powtórz operację'
    },
    operationErrorWithoutCallback: {
      title: 'Wystąpił błąd komunikacji z serwerem',
      desc: 'Zweryfikuj na liście czy dane zapisały się poprawnie. Jeśli nie - dokonaj operacji dodawania ponownie.'
    }
  },
  help: {
    emailLabel: 'pod adresem e-mail:',
    emailAddress: 'partner@bookero.pl',
    heading: 'Jeśli potrzebujesz pomocy w konfiguracji konta lub masz problemy z funkcjonowaniem systemu, jesteśmy do Twojej dyspozycji:',
    newsLabel: 'przydatne instrukcje i opisy funkcji znajdziesz na stronie:',
    newsAddress: 'www.bookero.pl/news',
    phoneLabel: 'pod numerem telefonu:',
    phoneNumber: '+48 790 328 686',
    title: 'Pomoc'
  },
  history: {
    additionalInformations: 'Dodatkowe informacje',
    client: 'Rezerwujący',
    date: 'Data',
    exportAs: 'Eksportuj jako ',
    filePrefix: 'historia-rezerwacji.',
    noReservations: 'Nie znaleziono żadnych rezerwacji...',
    noReservationsForGivenFilters: 'Nie znaleziono żadnych rezerwacji spełniających podane kryteria...',
    service: 'Usługa',
    status: 'Status rezerwacji',
    statusCancelled: 'Anulowane',
    statusClientNotPresent: 'Klient nieobecny',
    statusConfirmed: 'Potwierdzone',
    statusNew: 'Nowe zapytanie',
    statusRejected: 'Odrzucone',
    statusTitle: 'Status',
    statusWaitingList: 'Lista rezerwowa',
    title: 'Historia rezerwacji',
    worker: 'Pracownik'
  },
  historyListItem: {
    call: 'Zadzwoń',
    cancelled: 'Anulowane',
    cardRegistered: 'Karta zarejestrowana',
    cartID: 'ID koszyka:',
    category: 'Kategoria: ',
    clientNotPresent: 'Klient nieobecny',
    confirmed: 'Potwierdzone',
    editReservation: 'Edytuj rezerwację',
    formSent: 'Formularz wysłano:',
    newRequest: 'Nowe zapytanie',
    paid: 'Zapłacone',
    rejected: 'Odrzucone',
    reservationDetails: 'Szczegóły rezerwacji #{id}',
    reservationParentDetails: 'Rezerwacja główna #{id}',
    restoreReservation: 'Przywróć rezerwację',
    seeMore: 'Zobacz więcej',
    sendEmail: 'Wyślij e-mail',
    unPaid: 'Niezapłacone',
    waitingList: 'Lista rezerwowa'
  },
  login: {
    allFieldsAreRequired: 'Wypełnienie wszystkich pól jest wymagane do zalogowania się.',
    anErrorOccurredPleaseCheckInternetConnection: 'Wystąpił błąd podczas logowania. Sprawdź swoje połaczenie z Internetem i spróbuj ponownie.',
    anErrorOccurredUseFormBelow: 'Wystąpił błąd podczas logowania. Zaloguj się przy użyciu formularza:',
    email: 'Adres e-mail:',
    invalidData: 'Twoje dane logowania są niepoprawne. Zaloguj się przy użyciu formularza:',
    invalidLoginData: 'Podane dane logowania są niepoprawne.',
    login: 'Zaloguj się',
    logging: 'Logowanie...',
    noAccount: 'Nie masz konta?',
    password: 'Hasło:',
    passwordChanged: 'Twoje hasło zostało zmienione. Możesz teraz zalogować się używając swojego nowego hasła.',
    passwordReminder: 'Przypomnij hasło',
    registerForFree: 'Zarejestruj się i korzystaj za darmo!',
    title: 'Twoje rezerwacje na klik',
    yourEmail: 'Wpisz swój adres e-mail',
    yourPassword: 'Wpisz swoje hasło'
  },
  integrationPopup: {
    title: 'Kod pluginu'
  },
  integrations: {
    apiKey: 'API Key:',
    dontShareAPIKey: 'prosimy nie udostępniać osobom nieupoważnionym klucza API, gdyż przy jego pomocy można zarządzać rezerwacjami bez konieczności podawania danych do logowania.',
    downloadIntegrationCode: 'Pobierz kod integracji',
    downloadInstallationFile: 'Pobierz plik instalacyjny',
    fbDesc1: 'Aby móc zintegrować stronę z Facebook musisz mieć włączoną stronę www. Włącz ją w',
    fbDesc2: 'zmieniając wartość parametru Moja strona www na TAK. Następnie w ustawieniach przejdź do zakładki Moja strona i wybierz swoją subdomenę. Swoją stronę będziesz mógł w pełni edytować w zakładce Moja strona w głównym menu Bookero.',
    fbDescBtn: 'ustawieniach',
    fbTitle: 'Integracja z Facebookiem',
    fbIntroText: 'Integracja z Facebook polega na przekierowaniu użytkownika za pomocą przycisku „Skontaktuj się z nami” na podstronę, na której umieszczony jest formularz rezerwacyjny.',
    fbIntroTitle: 'Jak włączyć integrację?',
    fbIntroDescBtn: 'Dowiedz się jak to zrobić',
    fbIntroDescBtnClose: 'Ukryj instrukcję',
    fbIntroDesc1: 'Będąc zalogowanym na FB, kliknij w przycisk skróconego menu znajdujący się pod przyciskiem edycji strony.',
    fbIntroDesc2: 'Z rozwiniętej listy wybierz opcję „Edytowanie przycisku działania”.',
    fbIntroDesc3: 'Następnie kliknij w przycisk „Zmień przycisk”.',
    fbIntroDesc4: 'Z rozwiniętej listy wybierz opcję „Skontaktuj się z nami”, a następnie kliknij w przycisk „Dalej”.',
    fbIntroDesc5: 'W dedykowanym polu wprowadź adres witryny, na której znajduje się formularz rezerwacyjny i zapisz zmianę.',
    fbIntroDesc6: 'Gotowe!',
    inlineBoxTitle: 'Inline Box',
    inlineBoxDesc1: 'Wtyczka typu Inline Box dodaje formularz rezerwacji we wskazanym przez Ciebie miejscu na stronie. Umieść w wybranym miejscu kontener <code>div</code> z atrybutem <code>id</code> równym <code>bookero</code>:',
    inlineBoxDesc2: 'Następnie umieść pobrany kod integracji tuż przed zamknięciem sekcji <code>&lt;/body&gt;</code>.',
    inlineBoxDesc3: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru plugin_css na false.',
    inlineBoxDesc4: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru bookero_plugin_css na false.',
    joomlaTitle: 'Joomla',
    joomlaDesc1: 'Jeśli korzystasz z systemu Joomla!, możesz skrzystać z naszego pluginu do wyświetlania formularza rezerwacji.',
    joomlaDesc2: 'Pobierz plik instalacyjny i wgraj go do systemu przy pomocy instalatora rozszerzeń. Przejdź do listy dodatków i opublikuj plugin Bookero.',
    joomlaDesc3: 'W konfiguracji pluginu wklej ID Wtyczki do pola o tej samej nazwie:',
    pluginID: 'ID wtyczki:',
    monthlyBoxTitle: 'Monthly Box',
    monthlyBoxDesc1: 'Wtyczka typu Monthly Box dodaje formularz rezerwacji we wskazanym przez Ciebie miejscu na stronie. Umieść w wybranym miejscu kontener <code>div</code> z atrybutem <code>id</code> równym <code>bookero</code>:',
    monthlyBoxDesc2: 'Następnie umieść pobrany kod integracji tuż przed zamknięciem sekcji <code>&lt;/body&gt;</code>.',
    monthlyBoxDesc3: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru plugin_css na false.',
    monthlyBoxDesc4: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru bookero_plugin_css na false.',
    stickyBoxTitle: 'Sticky Box',
    stickyBoxDesc1: 'Wtyczka typu Sticky Box dodaje formularz rezerwacji w stałej pozycji strony, przyczepiony do dolnej krawędzi przeglądarki.',
    stickyBoxDesc2: 'Nie musisz dodawać żadnego dodatkowego kontenera <code>&lt;div&gt;</code>.',
    stickyBoxDesc3: 'Po prostu umieść pobrany kod integracji tuż przed zamknięciem sekcji <code>&lt;/body&gt;</code>.',
    stickyBoxDesc4: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru plugin_css na false.',
    stickyBoxDesc5: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru bookero_plugin_css na false.',
    title: 'Integracje',
    warning: 'Uwaga!',
    webWaveTitle: 'Integracja z WebWave CMS',
    webWaveStep1Title: 'Krok 1.',
    webWaveStep1Desc: 'Aby dodać formularz do swojej strony na webwavecms.com wchodzimy w jej edycję i klikamy w przycisk <strong>„Dowolny HTML, CSS, JS”</strong> dostępny po lewej stronie na liście funkcji.',
    webWaveStep2Title: 'Krok 2.',
    webWaveStep2Desc: 'Na środku strony <strong>wyświetli się pole</strong> w kształcie zielonego kwadratu, którego wielkość oraz położenie można dowolnie zmieniać. Klikając w nie wyświetli się <strong>okno z edytorem HTML</strong>, do którego <strong>wklejamy odpowiedni kod</strong> w zależności do tego jaki rodzaj wtyczki chcemy zastosować na stronie.',
    webWaveStep3Title: 'Krok 3.',
    webWaveStep3Desc: 'Po wklejeniu kodu według instrukcji dostępnej w zakładce <strong>„Integracje”</strong> klikamy w zielony przycisk <strong>„Zmień kod”</strong>, a następnie po zamknięciu okna klikamy w przycisk <strong>„Publikuj”</strong> dostępny w górnym menu. Zawartość elementu HTML będzie widoczna <strong>jedynie na opublikowanej stronie</strong>.',
    webWaveStep4Title: 'Gotowe!',
    webWaveStep4Desc: 'Na stronie w miejscu, w którym umieściliśmy pole pojawi się nam <strong>formularz rezerwacyjny</strong> Bookero.',
    weeklyBoxTitle: 'Weekly Box',
    weeklyBoxDesc1: 'Wtyczka typu Weekly Box dodaje formularz rezerwacji we wskazanym przez Ciebie miejscu na stronie. Umieść w wybranym miejscu kontener <code>div</code> z atrybutem <code>id</code> równym <code>bookero</code>:',
    weeklyBoxDesc2: 'Następnie umieść pobrany kod integracji tuż przed zamknięciem sekcji <code>&lt;/body&gt;</code>.',
    weeklyBoxDesc3: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru plugin_css na false.',
    weeklyBoxDesc4: 'Jeśli chcesz ustawić własne style css dla formularzy, zmień wartość parametru bookero_plugin_css na false.',
    wpTitle: 'WordPress',
    wpDesc1: 'Jeśli korzystasz z systemu WordPress, możesz skrzystać z naszej wtyczki do wyświetlania formularza rezerwacji.',
    wpDesc2: 'Pobierz plik instalacyjny i wgraj go do systemu przy pomocy instalatora wtyczek. Aktywuj rozszerzenie Bookero i przejdź do konfiguracji.',
    wpDesc3: 'W konfiguracji wtyczki wklej API Key do pola o tej samej nazwie:'
  },
  invoiceDetailsPopup: {
    address: 'Adres',
    amount: 'Kwota netto',
    companyTitle: 'Nazwa klienta',
    errorMessageDesc: 'Podczas pobierania danych faktury wystąpił błąd',
    errorMessageTitle: 'Wystąpił błąd',
    gtu: 'GTU',
    inquiryStatus: 'Status rezerwacji',
    issueDate: 'Data wystawienia',
    itemAmount: 'Cena netto',
    itemPrice: 'Jednostkowa cena netto',
    itemTotal: 'Cena brutto',
    itemVAT: 'VAT',
    name: 'Produkt',
    nip: 'NIP',
    notes: 'Uwagi',
    onInvoice: 'Na fakturze',
    onReceipt: 'Na paragonie',
    paymentDate: 'Data płatności',
    paymentStatus: 'Status płatności',
    paymentType: 'Metoda płatności',
    qty: 'Ilość',
    titleInvoice: 'Szczegóły faktury {number}',
    titleReceipt: 'Szczegóły paragonu {number}',
    vat: 'Kwota VAT'
  },
  invoices: {
    amount: 'Kwota',
    companyName: 'Odbiorca dokumentu',
    dueDate: 'Płatność do',
    inquiries: 'Rezerwacje',
    isCompany: 'Na kogo?',
    issueDate: 'Wystawiono',
    listItem: {
      company: 'Firma',
      create: 'Wygeneruj dokument',
      customer: 'Os. fizyczna',
      delete: 'Usuń',
      download: 'Pobierz',
      errorNotCreated: 'Nie udało się wygenerować dokumentu.',
      errorNotCreatedDesc: 'Podczas integracji dokumentu wystąpił błąd: ',
      invoice: 'Faktura VAT',
      invoiceNotRemoved: 'Nie udało się usunąć dokumentu',
      invoiceRemoved: 'Pomyślnie usunięto dokument',
      receipt: 'Paragon',
      removeConfirmTitle: 'Usuwanie dokumentu',
      removeConfirmDesc: 'Czy na pewno chcesz usunąć ten dokument?',
      removeConfirmIntegratedInvoiceTitle: 'Ten dokument jest już zintegrowana',
      removeConfirmIntegratedInvoiceDesc: 'Czy na pewno chcesz usunąć ten dokument?',
      seeDetails: 'Zobacz szczegóły'
    },
    noInvoices: 'Brak dokumentów sprzedażowych...',
    noInvoicesForGivenFilters: 'Brak dokumentów sprzedażowych spełniających podane kryteria...',
    number: 'Numer',
    statuses: {
      all: 'Wszystkie dokumenty',
      issued: 'Dokumenty wystawione',
      notReady: 'Dokumenty niepełne',
      ready: 'Dokumenty gotowe do wystawienia'
    },
    title: 'Dokumenty sprzedażowe',
    type: 'Rodzaj',
    types: {
      all: 'Faktury i paragony',
      invoices: 'Tylko faktury',
      receipts: 'Tylko paragony'
    }
  },
  myPage: {
    banner: 'Banner',
    bannerType: 'Typ bannera',
    darkText: 'Ciemny',
    dynamicSize: 'Dynamiczny rozmiar',
    fullScreen: 'Pełny ekran',
    galleryType: 'Rodzaj galerii',
    galleryTypeBig: 'Duże zdjęcia',
    galleryTypeSmall: 'Małe zdjęcia z możliwością powiększania',
    galleryTypeLogo: 'Galeria partnerów',
    lightText: 'Jasny',
    textColor: 'Odcień tekstu'
  },
  myPageSection: {
    addColumn: 'Dodaj kolumnę',
    addRow: 'Dodaj wiersz',
    background: 'Tło',
    bgAndContactData: 'Tło i dane kontaktowe',
    buttonText: 'Treść przycisku:',
    buttonUrl: 'URL przycisku:',
    buttonTargetBlank: 'Otwórz link w nowym oknie',
    category: 'Kategoria ',
    category1: 'Kategoria 1',
    columnContent: 'Treść kolumny',
    containerType: 'Rodzaj kontenera:',
    dark: 'Ciemny',
    dragAndDropImageHere: 'Przeciągnij i upuść obraz tutaj',
    heading: 'Nagłówek',
    image: 'Obrazek',
    imageAlignment: 'Wyrównanie grafiki:',
    imageRemoved: 'Grafika została usunięta',
    imageType: 'Rodzaj grafiki:',
    inlineBoxForm: 'Formularz typu Inline Box',
    left: 'Left',
    light: 'Jasny',
    loadingData: 'Ładowanie danych...',
    loadingEditor: 'Trwa ładowanie edytora...',
    loadingImages: 'Trwa ładowanie zdjęć...',
    mapAndContactData: 'Mapa i dane kontaktowe',
    monthlyBoxForm: 'Formularz typu Monthly Box',
    name: 'Nazwa:',
    noImagesInGallery: 'Brak zdjęć w galerii...',
    or: 'lub',
    removeBanner: 'Usuń banner',
    removeBackgroundImage: 'Usuń grafikę tła',
    removeImage: 'Usuń grafikę',
    removeInProgress: 'Trwa usuwanie...',
    removeSectionTitle: 'Usuwanie sekcji',
    removeSectionDesc: 'Czy na pewno chcesz usunąć wybraną sekcję?',
    removeSectionButton: 'Usuń sekcję',
    right: 'Right',
    savingSection: 'Zapisywanie konfiguracji sekcji...',
    sectionAdditionalContent: 'Treść dodatkowa:',
    sectionBackgroundImage: 'Grafika tła:',
    sectionDescription: 'Dodatkowy tekst pod tytułem:',
    sectionImage: 'Grafika:',
    sectionTitle: 'Tytuł sekcji:',
    selectedSectionNotSaved: 'Wybrana sekcja nie została zapisana. Spróbuj ponownie.',
    selectedSectionRemoved: 'Wybrana sekcja została usunięta',
    selectedSectionSaved: 'Wybrana sekcja została zapisana',
    selectFiles: 'Wybierz pliki',
    showOpeningHoursTitle: 'Pokazuj godziny otwarcia',
    showSectionTitle: 'Pokaż tytuł sekcji:',
    showServiceTime: 'Pokazuj czas usług:',
    showServicePrice: 'Pokazuj cenę usług:',
    submitNewFileToChangeBackgroundImage: 'Wyślij nowy plik by zmienić grafikę tła',
    submitNewFileToChangeBanner: 'Wyślij nowy plik by zmienić banner',
    submitNewFileToChangeImage: 'Wyślij nowy plik by zmienić grafikę',
    visibilityInMenu: 'Widoczność w menu:',
    textColor: 'Odcień tekstu:',
    types: {
      text: 'Strona tekstowa',
      banner: 'Banner',
      gallery: 'Galeria',
      pricelist: 'Cennik',
      reservation: 'Rezerwacja + Kontakt',
      textimage: 'Strona tekstowa + Grafika',
      services: 'Lista usług',
      workers: 'Lista pracowników'
    },
    uploadInProgress: 'Trwa wysyłanie zdjęć...',
    weeklyBoxForm: 'Formularz typu Weekly Box'
  },
  myPageSectionPopup: {
    addSection: 'Dodaj sekcję',
    addSectionTitle: 'Dodaj sekcję strony',
    bannerSection: 'Banner',
    gallerySection: 'Galeria',
    newSectionAdded: 'Nowa sekcja została dodana',
    newSectionNotAdded: 'Nie udało się dodać nowej sekcji',
    pricingSection: 'Cennik',
    reservationSection: 'Rezerwacja + Kontakt',
    sectionName: 'Nazwa sekcji:',
    sectionNameIsRequired: 'Nazwa sekcji jest wymagana',
    sectionType: 'Typ sekcji:',
    sectionTypeIsRequired: 'Określenie typu sekcji jest wymagane',
    selectSectionType: 'Wybierz typ sekcji',
    servicesSection: 'Lista usług',
    showInMenu: 'Pokaż w menu:',
    textImageSection: 'Strona tekstowa + Grafika',
    textSection: 'Strona tekstowa',
    workersSection: 'Lista pracowników'
  },
  news: {
    allNewsMarkedAsRead: 'Wszystkie informacje oznaczono jako przeczytane',
    collapse: 'Zwiń',
    loadingNews: 'Trwa ładowanie wiadomości...',
    markAllAsRead: 'Oznacz wszystkie jako przeczytane',
    readMore: 'Dowiedz się więcej',
    title: 'Nowości w Bookero',
    unreaded: 'Nieprzeczytane',
    youHaveUnreadedNews: 'Brak nieprzeczytanych wiadomości | {n} nieprzeczytana wiadomość | {n} nieprzeczytane wiadomości | {n} nieprzeczytanych wiadomości'
  },
  noPermissions: {
    title: 'Brak uprawnień',
    desc: 'Nie masz uprawnień do przeglądania tej strony...'
  },
  notifications: {
    all: 'Wszystkie',
    emptyState: 'Brak powiadomień',
    markAllAsRead: 'Oznacz wszystkie jako przeczytane',
    onlyUnread: 'Tylko nieprzeczytane ({unreadCount})',
    pleaseWait: 'Proszę czekać...'
  },
  openingHours: {
    applyRule: 'Zastosuj regułę',
    applyToAll: 'Zastosowanie: wszystko',
    applyToOnce: 'Zastosowanie: jednorazowo',
    applyToEveryYear: 'Zastosowanie: powtarzaj co roku',
    date: 'Data',
    newCompanyRule: 'Nowa reguła firmy',
    newWorkerRule: 'Nowa reguła pracownika',
    noOpeningHoursRules: 'Nie znaleziono żadnych reguł otwarcia...',
    noWorkerOpeningHoursRules: 'Nie znaleziono żadnych reguł godzin pracy...',
    rule: 'Reguła',
    ruleAll: 'Reguła: wszystko',
    ruleAppliesTo: 'Reguła dotyczy:',
    ruleChangedWorkHours: 'Reguła: zmiana godzin pracy',
    ruleFreeDay: 'Reguła: wolne od pracy',
    ruleForAll: 'Reguła dla: wszystko',
    ruleForCompany: 'Reguła dla: firma',
    ruleForWorker: 'Reguła dla: pracownik',
    showActive: 'Pokaż: aktywne',
    showAll: 'Pokaż: wszystko',
    showOutdated: 'Pokaż: przeterminowane',
    title: 'Reguły otwarcia'
  },
  openingHoursCompanyForm: {
    addTitle: 'Dodawanie reguły godzin otwarcia firmy',
    applyRule: 'Zastosuj regułę:',
    basicData: 'Podstawowe dane',
    changeWorkHours: 'Zmiana godzin pracy',
    dateRange: 'Zakres dat:',
    editTitle: 'Edycja reguły godzin otwarcia firmy',
    forRulesRepeatingEveryYearDescription: 'W wypadku reguł powtarzanych co roku należy określić godziny pracy wspólne dla wszystkich dni z wybranego zakresu dat. Jeżeli potrzebujesz zdefiniować różne godziny otwarcia dla poszczególnych dni, należy stworzyć osobne reguły na każdy dzień z danego zakresu dat.',
    modifiedWorkHours: 'Zmodyfikowane godziny pracy firmy',
    noCategory: 'Bez kategorii',
    onceTime: 'Jeden raz',
    repeatEveryYear: 'Powtarzaj co roku',
    rule: 'Reguła:',
    ruleAdded: 'Reguła została dodana',
    ruleDataChanged: 'Dane reguły zostały zmienione'
  },
  openingHoursCompanyService: {
    availabilityTheSameAsCompanyHours: 'Dostępność taka sama jak godziny pracy firmy'
  },
  openingHoursListItem: {
    applyRule: 'Zastosuj regułę:',
    changedWorkHours: 'Zmiana godzin pracy',
    company: 'Firmy',
    editRule: 'Edytuj regułę',
    onceTime: 'Jeden raz',
    removeRule: 'Usuń regułę',
    removeRuleTitle: 'Usuwanie reguły otwarcia',
    removeRuleDesc: 'Czy na pewno chcesz usunąć wybraną regułę otwarcia?',
    removeRuleBtn: 'Usuń regułę',
    removedRule: 'Wybrana reguła została usunięta',
    repeatsEveryYear: 'Powtarza się co roku',
    rule: 'Reguła:',
    rulesAppliesTo: 'Reguła dotyczy:',
    since: 'od:',
    to: 'do:'
  },
  openingHoursWorkerForm: {
    addRuleTitle: 'Dodawanie reguły godzin pracy pracownika',
    applyRule: 'Zastosuj regułę:',
    basicData: 'Podstawowe dane',
    changedWorkHours: 'Zmiana godzin pracy',
    dateRange: 'Zakres dat:',
    editRuleTitle: 'Edycja reguły godzin pracy pracownika',
    everyYear: 'Powtarzaj co roku',
    forRulesRepeatedEveryYearDescription: 'W wypadku reguł powtarzanych co roku należy określić godziny pracy wspólne dla wszystkich dni z wybranego zakresu dat. Jeżeli potrzebujesz zdefiniować różne godziny otwarcia dla poszczególnych dni, należy stworzyć osobne reguły na każdy dzień z danego zakresu dat.',
    modifiedWorkHours: 'Zmodyfikowane godziny pracy',
    onceTime: 'Jeden raz',
    rule: 'Reguła:',
    ruleAdded: 'Reguła została dodana',
    ruleDataChanged: 'Dane reguły zostały zmienione',
    selectWorker: 'Wybierz pracownika',
    selectWorkerToSpecifyWorkHour: 'Wybierz pracownika aby określić godziny pracy...',
    youMustSelectWorker: 'Musisz wybrać pracownika',
    worker: 'Pracownik:'
  },
  openingHoursWorkerPopup: {
    saveChanges: 'Zapisz zmiany',
    savingChanges: 'Zapisywanie zmian'
  },
  passwordReminder: {
    anErrorOccurred: 'Wystąpił problem przy resetowaniu hasła - spróbuj ponownie.',
    backToLogin: 'Wróć do formularza logowania',
    emailIsRequired: 'Wypełnienie pola z adresem e-mail jest wymagane do zresetowania hasła.',
    ifEmailExistLinkSent: 'Jeżeli podany adres e-mail istnieje w naszej bazie danych to został na niego wysłany link prowadzący do formularza zmiany hasła.',
    invalidEmail: 'Podany adres e-mail jest niepoprawny',
    provideEmailConnectedWithAccount: 'Podaj adres e-mail powiązany z Twoim kontem aby zresetować hasło:',
    reset: 'Resetuj hasło',
    resetting: 'Resetowanie...',
    title: 'Zapomniałeś hasła?',
    yourEmail: 'Wpisz swój adres e-mail',
    wantToLogin: 'Chcesz się zalogować?'
  },
  passwordReset: {
    backToLogin: 'Wróć do formularza logowania',
    bothFieldsRequired: 'Należy wypełnić oba pola z hasłami.',
    differentPasswords: 'Podane hasła nie są identyczne',
    invalidPasswords: 'Podane hasła są nieprawidłowe - hasło musi się składać co najmniej z 6 znaków.',
    invalidToken1: 'Nieprawidłowy token. Kliknij link z otrzymanego maila ponownie lub',
    invalidToken2: 'zresetuj hasło',
    invalidToken3: 'jeszcze raz.',
    newPassword: 'Podaj nowe hasło:',
    repeatPassword: 'Powtórz hasło:',
    reset: 'Resetuj hasło',
    resetting: 'Trwa resetowanie...',
    resetError: 'Wystąpił problem przy resetowaniu hasła - spróbuj ponownie.',
    title: 'Resetowanie hasła,',
    wantToLogin: 'Chcesz się zalogować?',
    yourNewPassword: 'Twoje nowe hasło',
    yourRepeatedPassword: 'Powtórz hasło'
  },
  paymentMethodForm: {
    addTitle: 'Dodawanie metody płatności',
    apiAuthToken: 'Token Autoryzacyjny API:',
    basicPrice: 'Cena podstawowa:',
    cash: 'Gotówka',
    code: 'Kod:',
    configureServicesTitle: 'Konfiguruj usługi korzystające z tej metody płatności',
    configureTitle: 'Konfiguruj sposób obsługi płatności',
    crcKey: 'Klucz CRC:',
    editTitle: 'Edycja metody płatności',
    forPerson: 'za osobę',
    forReservation: 'za rezerwację',
    hash: 'Hash:',
    key: 'Klucz API:',
    merchantID: 'Identyfikator klienta:',
    name: 'Nazwa metody płatności:',
    paymentType: 'Rodzaj płatności:',
    password: 'Hasło:',
    paymentCurrency: 'Waluta płatności:',
    paymentMethodAdded: 'Metoda płatności została dodana',
    paymentMethodNotSaved: 'Wystąpił błąd podczas zapisu metody płatności',
    paymentMethodSettingsSaved: 'Ustawienia metody płatności zostały zmienione',
    posID: 'Id punktu płatności (pos_id):',
    pin: 'PIN:',
    privateKey: 'Klucz prywatny',
    publicKey: 'Klucz publiczny',
    receiverID: 'Identyfikator odbiorcy:',
    redirectDescription: 'Jest to adres strony na którą przekierowywany jest klient po dokonaniu płatności.<br>Adres ten powinien zaczynać się od "http://" lub "https://"',
    returnUrl: 'Adres URL powrotu po płatności:',
    secondaryKeyMD5: 'Drugi klucz (MD5):',
    secret: 'Klucz sygnatury:',
    sellerID: 'ID sprzedawcy:',
    serviceID: 'Identyfikator sklepu:',
    serviceKey: 'Klucz sklepu:',
    shopID: 'ID sklepu:',
    signature: 'Sygnatura:',
    timeInHoursForPayment: 'Czas w godzinach na płatność:',
    timeMustBeBiggerThanZero: 'Czas na płatność musi być większy od zera.',
    username: 'Nazwa użytkownika:',
    visibleOnlyForAdmin: 'Widoczne tylko dla administratora',
    youCannotHideThisPaymentMethodAsItIsDefaultMethod: 'Nie można ukryć tej metody płatności, ponieważ jest ona domyślną metodą płatności.'
  },
  payments: {
    additionalInformation: 'Dodatkowe informacje',
    client: 'Rezerwujący',
    cost: 'Koszt',
    date: 'Data',
    exportAs: 'Eksportuj jako ',
    filePrefix: 'platnosci.',
    noTransactions: 'Nie znaleziono żadnych rezerwacji...',
    noTransactionsForGivenCriteria: 'Nie znaleziono żadnych rezerwacji spełniających podane kryteria...',
    service: 'Usługa',
    status: 'Status',
    statusCanceled: 'Anulowana',
    statusCompleted: 'Zakończona',
    statusNew: 'Nowa',
    statusPending: 'W trakcie rozliczenia',
    title: 'Historia transakcji',
    transactionStatus: 'Status transakcji',
    worker: 'Pracownik'
  },
  paymentsListItem: {
    call: 'Zadzwoń',
    cartID: 'ID koszyka:',
    category: 'Kategoria: ',
    cancelledReservation: 'Anulowana',
    cardRegistered: 'Karta zarejestrowana',
    change: 'Zmień',
    clientNotPresent: 'Klient nieobecny',
    completedReservation: 'Zakończona',
    formSent: 'Formularz wysłano:',
    newReservation: 'Nowa',
    paymentCollected: 'Płatność pobrana',
    paymentMethod: 'Sposób płatności: ',
    paymentRegistered: 'Rejestracja płatności',
    pendingReservation: 'W trakcie rozliczenia',
    reservationDetails: 'Szczegóły rezerwacji',
    reservationParentDetails: 'Rezerwacja główna #{id}',
    seeMore: 'Zobacz więcej',
    sendEmail: 'Wyślij e-mail'
  },
  paymentStatusPopup: {
    changeStatus: 'Zmień status',
    inquiryIsCyclic: 'Zmieniając status, zmieniasz go dla całego cyklu a nie dla tej pojedynczej rezerwacji.',
    notifyClient: 'Powiadom klienta:',
    saving: 'Zapisywanie...',
    status: 'Status:',
    statusCancelled: 'Anulowana',
    statusChanged: 'Status płatności został zmieniony',
    statusCompleted: 'Zakończona',
    statusNew: 'Nowa',
    statusPending: 'W trakcie rozliczenia',
    title: 'Zmień status płatności',
    warning: 'Uwaga!'
  },
  priceRules: {
    addNewRule: 'Dodaj nową regułę',
    newPrice: 'Nowa cena',
    noPriceRules: 'Nie znaleziono żadnych reguł cen...',
    priceChangeDependsOn: 'Zmiana ceny zależy od:',
    rulesOrderingAffectsPriority: 'Kolejność reguł decyduje o ich priorytecie',
    rulesOrderingSaved: 'Kolejność reguł została zapisana',
    title: 'Reguły cen',
    warning: 'Uwaga!'
  },
  priceRulesListItem: {
    additionalParams: 'Dodatkowe parametry:',
    anyValue: 'dowolna wartość',
    daysCount: 'Liczba dni:',
    editRule: 'Edytuj regułę',
    newPrice: 'Nowa cena:',
    removePriceRuleTitle: 'Usuwanie reguły cen',
    removePriceRuleDesc: 'Czy na pewno chcesz usunąć wybraną regułę cen?',
    removePriceRule: 'Usuń regułę',
    removeRule: 'Usuń regułę',
    reservationDay: 'Dzień rezerwacji:',
    reservationHour: 'Godzina rezerwacji:',
    selectedRuleHasBeenRemoved: 'Wybrana reguła została usunięta'
  },
  priceRulesForm: {
    addTitle: 'Dodawanie reguły cen',
    childrenNumberRange: 'Zakres dzieci:',
    considerAlso: 'Uwzględnij:',
    daysLengthRange: 'Zakres liczby dni:',
    dateRange: 'Zakres dat:',
    daysRange: 'Zakres dni:',
    dayOfReservation: 'Dzień na jaki składana jest rezerwacja',
    dayWhenReservationWasSent: 'Dzień złożenia rezerwacji',
    dependsFromAdditionalParams: 'Zależne od dodatkowych parametrów:',
    dependsFromChildrenNumber: 'Zależne od liczby dzieci:',
    dependsFromDate: 'Zależne od daty rezerwacji:',
    dependsFromDay: 'Zależne od dnia rezerwacji:',
    dependsFromDaysLength: 'Zależne od liczby dni:',
    dependsFromHour: 'Zależne od godziny rezerwacji:',
    dependsFromPeopleNumber: 'Zależne od liczby osób:',
    dependsFromWorkers: 'Zależne od pracowników:',
    editTitle: 'Edycja reguły cen',
    everyWeek: 'Co tydzień',
    everyTwoWeeks: 'Co dwa tygodnie',
    everyFourWeeks: 'Co cztery tygodnie',
    everyDay: 'Codziennie',
    hoursRange: 'Zakres godzin:',
    newPrice: 'Nowa cena:',
    newPriceWithDash: 'Nowa cena - ',
    noServiceParameters: 'Brak parametrów powiązanych z wybraną usługą',
    paramsTitle: 'Parametry reguły',
    parameterValues: 'Wartości parametrów:',
    periodicity: 'Cykliczność:',
    peopleNumberRange: 'Zakres osób:',
    priceRuleAdded: 'Reguła cen została dodana',
    priceRuleDataChanged: 'Dane reguły cen zostały zmienione',
    requiredConditionsForTheRule: 'Warunki wymagane do spełnienia reguły',
    selectValue: 'Wybierz wartość',
    workersDoingService: 'Pracownicy wykonujący wybraną usługę',
    youMustSelectAtLeastOneDay: 'Musisz wybrać co najmniej jeden dzień',
    youMustSelectAtLeastOneParam: 'Musisz wybrać co najmniej jeden parametr',
    youMustSelectServiceToSelectWorkers: 'Musisz najpierw wybrać usługę'
  },
  register: {
    acceptingTosIsRequired: 'Akceptacja warunków jest wymagana do zarejestrowania się.',
    allFieldsAreRequired: 'Wypełnienie wszystkich pól i akceptacja warunków jest wymagana do zarejestrowania się.',
    anErrorOccurred: 'Wystąpił błąd podczas rejestracji. Sprawdź swoje połaczenie z Internetem i spróbuj ponownie.',
    companyName: 'Nazwa firmy:',
    doYouHaveAnAccount: 'Masz już konto?',
    email: 'Adres e-mail:',
    gdprText: 'Administratorem Twoich danych osobowych będzie SAFI STUDIO Paweł Nowakowski, ul. Spacerowa 25, 05-152 Czosnów, NIP: 531-161-08-55. Twoje dane będą przetwarzane w celu realizacji usługi systemu rezerwacji online, powiadomień systemowych oraz kontaktów mailowych i telefonicznych w celu pomocy przy obsłudze systemu. Szczegóły znajdziesz w <a href="https://www.bookero.pl/polityka-prywatnosci" target="_blank">polityce prywatności</a>.',
    login: 'Zaloguj się',
    optional: '(pole opcjonalne)',
    password: 'Hasło:',
    passwordsAreDifferent: 'Podane hasła nie są identyczne',
    passwordMustHave6Chars: 'Hasło musi się składać z co najmniej 6 znaków.',
    phone: 'Numer telefonu:',
    register: 'Zarejestruj się',
    repeatPassword: 'Powtórz hasło:',
    sending: 'Wysyłanie...',
    someFieldsAreInvalid: 'Niektóre pola wypełnione są niepoprawnie.',
    title: 'Twoje rezerwacje na klik',
    tosText: 'Zapoznałem się z <a href="https://www.bookero.pl/regulamin" target="_blank">regulaminem</a> i <a href="https://www.bookero.pl/polityka-prywatnosci" target="_blank">polityką prywatności</a> systemu Bookero oraz akceptuję ich warunki.',
    yourCompanyName: 'Wpisz nazwę swojej firmy',
    yourEmail: 'Wpisz swój adres e-mail',
    yourPassword: 'Wpisz swoje hasło',
    yourPhone: 'Wpisz numer telefonu',
    yourRepeatedPassword: 'Powtórz swoje hasło'
  },
  reservation: {
    acceptReservation: 'Zaakceptuj rezerwację',
    andService: 'i usługę',
    cancelReservation: 'Anuluj rezerwację',
    category: 'Kategoria: ',
    cardRegistered: 'Karta zarejestrowana',
    clientNotPresent: 'Klient się nie pojawił',
    clientNotPresentTitle: 'Klient nie przyszedł?',
    clientNotPresentDesc: 'Jeśli klient nie pojawił się, kliknij przycisk Tak, aby zanotować to w jego statystykach.',
    clientNotPresentBtn: 'Tak, klient się nie pojawił',
    clientNotPresentSaved: 'Zapisano nieobecność klienta',
    contactWithClient: 'Skontaktuj się z klientem',
    dateFormat: 'dddd, D MMMM YYYY',
    forThisHour: 'Na tę godzinę ',
    inProgress: 'W trakcie',
    moreInfoAboutReservation: 'Dowiedz się więcej o rezerwacji',
    moreInfoAboutBlockedDate: 'Dowiedz się więcej o blokadzie terminu',
    noPeopleInThisTerm: 'Brak osób w tym terminie',
    paid: 'Zapłacone',
    peopleCounter: 'os.',
    rejectReservation: 'Odrzuć rezerwację',
    reservations: 'rezerwacji',
    unblockDate: 'Odblokuj termin',
    unpaid: 'Niezapłacone',
    youHave: 'posiadasz: '
  },
  reservationsCart: {
    betweenStart: 'Między',
    betweenMiddle: 'a',
    seeCart: 'Zobacz koszyk',
    totalCost: 'Całkowity koszt:'
  },
  reservationsCartPopup: {
    acceptAll: 'Akceptuj wszystkie',
    emailNotificationsSent: 'Powiadomienie mailowe zostało wysłane do klienta',
    manualAcceptRequiredDesc: 'Niektórych rezerwacji nie udało się zaakceptować automatycznie.',
    manualAcceptRequiredTitle: 'Wymagana ręczna akceptacja',
    rejectAll: 'Odrzuć wszystkie',
    rejectPopupTitle: 'Odrzuć zapytania',
    rejectPopupDesc: 'Chcesz odrzucić te zapytania o termin czy dodać je do listy rezerwowej?',
    rejectPopupCancelButton: 'Odrzuć wszystkie',
    rejectPopupOkButton: 'Dodaj wszystkie do listy rezerwowej',
    title: 'Koszyk rezerwacji'
  },
  reservationDetails: {
    accepted: 'Zaakceptowana',
    acceptReservation: 'Zaakceptuj rezerwację',
    appliedDiscountQuote: 'Kwota rabatu:',
    attendance: 'Obecność',
    blockadeDescription: 'Opis',
    blockedToDate: 'Blokada wygasa:',
    blockedToDateCompanyBlockade: 'Koniec blokady:',
    blockingType: 'Typ blokady',
    blockingTypeCalendarDaily: 'Kalendarz usług na dni',
    blockingTypeCalendarHourly: 'Kalendarz usług godzinowych',
    blockingTypeService: 'Usługa',
    blockingTypeWorker: 'Pracownik',
    byAdministrator: 'administratora',
    byClient: 'klienta',
    cancelFutureWithoutPayments: 'Czy chcesz usunąć przyszłe rezerwacje utworzone podczas cykliczności? | Czy chcesz usunąć przyszłe rezerwacje utworzone podczas cykliczności? Usunięta zostanie 1 rezerwacja - zaczynając od dnia {date}. | Czy chcesz usunąć przyszłe rezerwacje utworzone podczas cykliczności? Usunięte zostaną {count} rezerwacje - zaczynając od dnia {date}. | Czy chcesz usunąć przyszłe rezerwacje utworzone podczas cykliczności? Usuniętych zostanie {count} rezerwacji - zaczynając od dnia {date}.',
    cancelFutureWithPayments: 'Czy chcesz usunąć przyszłe nieopłacone rezerwacje utworzone podczas cykliczności? | Czy chcesz usunąć przyszłe nieopłacone rezerwacje utworzone podczas cykliczności? Usunięta zostanie 1 rezerwacja - zaczynając od dnia {date}. | Czy chcesz usunąć przyszłe nieopłacone rezerwacje utworzone podczas cykliczności? Usunięte zostaną {count} rezerwacje - zaczynając od dnia {date}. | Czy chcesz usunąć przyszłe nieopłacone rezerwacje utworzone podczas cykliczności? Usuniętych zostanie {count} rezerwacji - zaczynając od dnia {date}.',
    cancelled: 'Anulowana',
    cancelledAt: 'Data anulowania:',
    cancelledBy: 'Anulowane przez:',
    cancelPeriodicity: 'anuluj odnawianie cyklu',
    cancelPeriodicityConfirmDesc: 'Utworzone już rezerwacje pozostaną w systemie, natomiast nie zostaną utworzone żadne nowe rezerwacje na podstawie konfiguracji cyklu.',
    cancelPeriodicityConfirmTitle: 'Odnawianie cyklu zostanie przerwane',
    cancelReservation: 'Anuluj rezerwację',
    cardRegistered: 'Karta zarejestrowana',
    category: 'Kategoria: ',
    changeDate: 'Zmień termin',
    changeIntoReservation: 'Zamień w rezerwację',
    changePaymentStatus: 'Zmień',
    clientNotPresent: 'Klient nieobecny',
    clientNotPresentSaved: 'Zmieniono status na nieobecny',
    clientPresent: 'Klient obecny',
    clientPresentReset: 'Zresetowano status obecności',
    clientPresentSaved: 'Zmieniono status na obecny',
    copy: 'Kopiuj',
    copyPaymentLink: 'Skopiuj link do płatności',
    copyGoogleMeetLink: 'Skopiuj link do Google Meet',
    createdAt: 'Data utworzenia:',
    createdBy: 'Utworzone przez:',
    customerEmail: 'E-mail rezerwującego:',
    customerPhone: 'Telefon rezerwującego:',
    emailAgreement: 'Zgoda na działania marketingowe poprzez e-mail',
    filledSurveys: 'Wypełnione ankiety:',
    givenAgreements: 'Wyrażone zgody:',
    googleCalendar: 'Kalendarz Google',
    googleMeetURL: 'Link do Google Meet',
    importedFrom: 'Zaimportowane z:',
    invoiceOrReceipt: 'Dokument sprzedaży:',
    lockmeReservationID: 'ID rezerwacji LockMe',
    minutes: 'min.',
    no: 'Nie',
    okCancelPeriodicity: 'OK, wyłącz odnawianie',
    outlookCalendar: 'Kalendarz Outlook',
    noteFromCalendar: 'Notatka z kalendarza:',
    payment: 'Płatność:',
    paymentDate: 'Termin płatności:',
    paymentLink: 'Link do płatności:',
    paymentMethod: 'Metoda płatności:',
    paymentStatusNew: 'Nowa',
    paymentStatusPending: 'W trakcie rozliczenia',
    paymentStatusCompleted: 'Zakończona',
    paymentStatusCancelled: 'Anulowana',
    paymentStatusCardRegistered: 'Karta zarejestrowana',
    paymentStatusPaymentRegistration: 'Rejestracja płatności',
    paymentStatusPaymentCollected: 'Płatność pobrana',
    paymentQuote: 'Kwota płatności:',
    periodicity: 'Cykliczność:',
    periodicityCancelFailed: 'Nie udało się wyłączyć automatycznego odnawiania cyklu - spróbuj ponownie.',
    phoneAgreement: 'Zgoda na działania marketingowe poprzez połączenia telefoniczne',
    rejected: 'Odrzucona',
    rejectReservation: 'Odrzuć rezerwację',
    reservedBy: 'Rezerwujący:',
    reservationDate: 'Termin:',
    reservationDateCompanyBlockade: 'Okres blokady:',
    reservationDuration: 'Czas trwania:',
    reservationHour: 'Godzina:',
    reservationParams: 'Parametry rezerwacji:',
    reservationParent: 'To jest rezerwacja główna cyklu',
    reservationParentDetails: 'Rezerwacja główna:',
    savingChanges: 'zapisywanie zmian...',
    seeSurveyResults: 'Zobacz odpowiedzi',
    status: 'Status:',
    title: 'Szczegóły rezerwacji',
    titleBlockedDate: 'Szczegóły blokady terminu',
    titleCompanyBlockedDate: 'Szczegóły blokady kalendarza',
    tosAndPrivacyPolicy: 'Zaakceptowany regulamin i polityka prywatności',
    qrCodeTickets: 'Bilety QRCode:',
    qrCodeTicketsDateOfUse: 'Daty wykorzystania:',
    usedDiscountCode: 'Użyty kod rabatowy:',
    usedQrCodeTickets: 'Wykorzystano:',
    yes: 'Tak',
    reservationWaitingListNotificationDate: 'Powiadomienie o zwolnieniu terminu:',
    waitingList: 'Lista rezerwowa',
    waitsForAccept: 'Oczekuje na akceptację',
    waitsForPayment: 'Oczekuje na płatność'
  },
  reservationForm: {
    addedNewPeriodicityDates: 'Brak | Zwiększasz pakiet rezerwacji o jeden dodatkowy termin | Zwiększasz pakiet rezerwacji o {count} dodatkowe terminy | Zwiększasz pakiet rezerwacji o {count} dodatkowych terminów',
    additionalInformations: 'Informacje dodatkowe',
    addNewPeriodicityDates: 'Dodaj kolejne terminy',
    addNewPeriodicityDatesTitle: 'Ile terminów dodać?',
    addNewPeriodicityDatesDesc: 'Określ ile terminów chcesz dodać. Pamiętaj, że maksymalnie można mieć 30 kolejnych terminów w rezerwacji.',
    addNewPeriodicityDatesLabel: 'Ile terminów dodać?',
    addNewPeriodicityDatesOk: 'Dodaj terminy',
    addNewPeriodicityDatesErrorTitle: 'Nie udało się dodać terminów',
    addNewPeriodicityDatesErrorDesc: 'Nie możesz dodać terminów | Możesz maksymalnie dodać 1 termin | Możesz maksymalnie dodać {max} terminy | Możesz maksymalnie dodać {max} terminów',
    annotations: {
      changedCurrency: 'Zmieniona waluta:',
      changedPrice: 'Zmieniona cena:',
      changedStatus: 'Zmieniony status:',
      changedSystem: 'Zmieniona metoda płatności:',
      changedPayment: 'Zmieniona metoda płatności:',
      reservation: 'Rezerwacja:',
      see: 'Zobacz rezerwacje, których to dotyczy.'
    },
    anyWorker: 'Dowolny pracownik',
    askForNewStatusTitle: 'Edytowana rezerwacja posiada status rezerwacji oczekującej na zatwierdzenie. Czy chcesz podczas zapisu zmienić status tej rezerwacji?',
    askForNewStatusBtnOk: 'Zapisz i zaakceptuj',
    askForNewStatusBtnCancel: 'Zapisz jako oczekującą',
    basicDataTitle: 'Podstawowe dane',
    belowListPresentsAtMax30NearestTerms: 'Poniższa lista prezentuje maksymalnie 30 najbliższych terminów.',
    cancelledReservationTitle: 'Edytowana rezerwacja posiada status rezerwacji anulowanej. Czy chcesz podczas zapisu zmienić status tej rezerwacji?',
    cancelledReservationOkBtn: 'Zapisz i przywróć',
    cancelledReservationCancelBtn: 'Zapisz jako anulowaną',
    cannotConvertSimpleReservationToCyclicService: 'W trybie edycji nie można już wybierać usług cyklicznych',
    cannotEditPriceDesc: 'Jeśli wybrano edycję obecnej i przyszłych rezerwacji, zmiana ceny rezerwacji nie jest możliwa.',
    cannotEditPriceTitle: 'Nie można edytować ceny',
    checkProfile: 'Sprawdź profil',
    cyclicReservation: 'Cykliczna do odwołania',
    day: 'Dzień',
    didYouMean: 'Czy chodziło Ci o:',
    discountCode: 'Kod rabatowy',
    doYouWantToChangeReservationStatus: 'Czy chcesz zmienić status rezerwacji?',
    duration: 'Czas trwania:',
    durationMustBeBiggerThanZero: 'Czas trwania usługi musi być większy od zera',
    editCyclicReservationTitle: 'Edycja rezerwacji cyklicznej',
    editCyclicReservationDesc: 'Wybrana rezerwacja jest cykliczna. Czy chcesz edytować wszystkie przyszłe rezerwacje czy tylko obecną?',
    editCyclicReservationBtnCancel: 'Edytuj tylko obecną',
    editCyclicReservationBtnOk: 'Edytuj wszystkie przyszłe',
    editedPriceIsForSingleReservation: 'Poniższa cena dotyczy tylko obecnie edytowanej rezerwacji',
    editedPriceIsForSingleReservationAndFutureOnes: 'Poniższa cena dotyczy tej i kolejnych rezerwacji',
    editedPriceIsForWholeCycle: 'Poniższa cena dotyczy ceny za cały cykl rezerwacji',
    editReservation: 'Edycja rezerwacji',
    email: 'E-mail',
    emailIsInvalid: 'Podany adres e-mail jest niepoprawny',
    emailIsRequired: 'Adres e-mail jest wymagany',
    errorChangedPriceTitle: 'Nie można zapisać zmian',
    errorChangedPriceDesc: 'Wprowadzone zmiany wpływają na cenę tej rezerwacji. Nie masz wystarczajacych uprawnień aby je zapisać. Skontaktuj się z właścicelem konta Bookero.',
    estimatedTimeForTheSelectedServiceIs: 'Szacowany czas dla wybranej usługi to:',
    fourWeeks: 'Cztery tygodnie',
    futurePaymentsHaveAnnotations: 'Wykryto przyszłe rezerwacje, które mają inną konfigurację płatności. Konfiguracje płatności tych rezerwacji nie zostaną nadpisane dopóki nie wybierzesz opcji nadpisania wszystkich przyszłych płatności.',
    givenPriceCanBeDifferentAccordingToPriceRules: 'Podana cena za usługę może się różnić w zależności od zdefiniowanych reguł cen.',
    invoiceAddress: 'Adres',
    invoiceCity: 'Miasto',
    invoiceCompanyTitle: 'Nazwa na fakturze',
    invoiceCountry: 'Kraj',
    invoiceDataTitle: 'Dane do faktury',
    invoiceEditDisabled: 'Zmiana ustawień faktur jest możliwa tylko podczas edycji bez modyfikacji przyszłych rezerwacji',
    invoiceIsCompany: 'Faktura na firmę',
    invoiceNip: 'NIP',
    invoicePostCode: 'Kod pocztowy',
    issueInvoice: 'Wystawić fakturę?',
    iReadAndAccept: 'Zapoznałem się oraz akceptuję',
    loadingTerms: 'Trwa ładowanie terminów...',
    nameAndSurname: 'Imię i nazwisko',
    nameIsRequired: 'Imię i nazwisko jest wymagane',
    nearestPossibleTerms: 'Najbliższe możliwe terminy',
    noFreeTermsForSelectedService: 'Brak wolnych terminów dla wybranej usługi',
    nonStandardTerm: 'Niestandardowy termin',
    notAvailableTermsDetectedDescAdd: 'dodawanie',
    notAvailableTermsDetectedDescEdit: 'edycję',
    notAvailableTermsDetectedTitle: 'Wykryto niedostępne terminy',
    notAvailableTermsDetectedDesc: 'Co najmniej jeden z wybranych terminów jest niedostępny. Czy chcesz mimo to, kontynuować {descPhrase} tej rezerwacji?',
    notAvailableTermsDetectedBtn: ' mimo to',
    notifyClient: 'Powiadom klienta',
    okChangePrice: 'Zmień cenę',
    oneTime: '1 raz',
    or: 'lub',
    originalPriceIs: 'Cena według cennika:',
    originalPriceIsWithDiscount: 'Cena według cennika po rabacie:',
    packageReservation: 'Pakiet rezerwacji',
    paymentMethod: 'Metoda płatności',
    paymentStatusNew: 'Nowa',
    paymentStatusPending: 'W trakcie rozliczenia',
    paymentStatusCanceled: 'Anulowana',
    paymentStatusCompleted: 'Zakończona',
    periodicityDaysPaymentReminder: 'Ile dni przed rezerwacją wysyłany jest link do płatności',
    periodicityHoursPaymentCancel: 'Na ile godzin przed rezerwacją jest ona anulowana w wypadku braku płatności',
    periodicityFirstPayment: 'Czy płatność za pierwszą rezerwację jest wymagana w momencie rezerwacji',
    periodicityTerminsSettings: 'Gdy zmienię termin powtarzającej się rezerwacji:',
    periodicityTerminsSettingsDates: 'Zmień daty kolejnych rezerwacji zgodnie z wybraną powtarzalnością',
    periodicityTerminsSettingsHours: 'Zmień godziny kolejnych rezerwacji zgodnie z wybraną godziną',
    periodicityType: 'Rodzaj cykliczności:',
    periodicitySettings: 'Ustawienia cykliczności',
    personalDataProcessing: 'Przetwarzanie danych osobowych',
    personalDataProcessingDesc: 'Zgody powinny zostać wyrażone przez klienta',
    phone: 'Telefon komórkowy',
    phoneIsInvalid: 'Podany numer telefonu jest niepoprawny',
    phoneIsRequired: 'Wymagany jest prawidłowy numer telefonu',
    previouslySelectedHourIsUnavailable: 'Wybrana godzina nie jest dostępna. Wybierz inny termin:',
    previouslySelectedHourIsUnavailableIn30Dates: 'Wybrana godzina nie jest dostępna wśród 30 najbliższych terminów. Wybierz inny termin:',
    previouslySelectedTermIsUnavailable: 'Wybrany termin nie jest dostępny. Wybierz inny termin:',
    priceForAllReservations: 'za cały cykl',
    priceForSingleReservation: 'za pojedynczą rezerwację',
    priceWillBeChangedForFutureInquiriesTitle: 'Uwaga!',
    priceWillBeChangedForFutureInquiriesDesc: 'Zmieniono cenę, która zostanie zastosowana też dla przyszłych rezerwacji (z wyłączeniem rezerwacji mających zmodyfikowane ustawienia płatności). Czy chcesz kontynuować?',
    priceWillBeChangedForFutureInquiriesAltDesc: 'Zmieniono cenę, która zostanie zastosowana też dla przyszłych rezerwacji. Czy chcesz kontynuować?',
    priceWillBeChangedForAllFutureInquiriesDesc: 'Zmieniono cenę, która zostanie zastosowana też dla wszystkich przyszłych rezerwacji. Czy chcesz kontynuować?',
    priceWillBeChangedForTheWholeCycleTitle: 'Uwaga!',
    priceWillBeChangedForTheWholeCycleDesc: 'Cena zostanie zmieniona dla całego cyklu',
    privacyPolicy: 'politykę prywatności',
    provideDiscountCode: 'Podaj kod rabatowy',
    provideProperChildrenNumber: 'Podaj poprawną liczbę dzieci',
    provideProperDaysNumber: 'Podaj poprawną liczbę dni',
    provideProperPeopleNumber: 'Podaj poprawną liczbę osób',
    provideYourOwnPrice: 'Podaj własną cenę',
    provideYourOwnPriceForReservation: 'Podaj własną cenę za rezerwację',
    provideYourOwnPriceForPackage: 'Podaj własną cenę za cały cykl rezerwacji',
    rejectedReservationTitle: 'Edytowana rezerwacja posiada status rezerwacji odrzuconej. Czy chcesz podczas zapisu zmienić status tej rezerwacji?',
    rejectedReservationOkBtn: 'Zapisz i zaakceptuj',
    rejectedReservationCancelBtn: 'Zapisz jako odrzuconą',
    repeatEvery: 'Powtarzaj co',
    reservationType: 'Rodzaj rezerwacji',
    required: '(wymagane)',
    search: 'Szukaj',
    searchSinceDay: 'Szukaj od dnia:',
    select: 'Wybierz',
    selectDate: 'Wybierz datę',
    selectMonth: 'Wybierz miesiąc',
    selectHour: 'Wybierz godzinę',
    selectPaymentMethod: 'Wybierz metodę',
    selectPaymentStatus: 'Wybierz status',
    selectPeriodicityType: 'Wybierz rodzaj cykliczności',
    selectTerm: 'Wybierz termin',
    selectWorker: 'Wybierz pracownika',
    showTerms: 'Pokaż terminy',
    youMustToSelectPeriodicityType: 'Należy wybrać rodzaj cykliczności',
    serviceIsRequired: 'Wybranie usługi jest wymagane',
    singleReservation: 'Rezerwacja pojedyncza',
    thisFieldIsRequired: 'To pole jest wymagane',
    thisTermIsUnavailable: 'Ten termin jest niedostępny',
    times: 'razy',
    toPay: 'Do zapłaty:',
    tos: 'regulamin rezerwacji',
    toSelectTermSelectService: 'Aby móc wybrać termin, musisz najpierw wybrać usługę.',
    toSelectTermSelectPeriodicityType: 'Aby móc wybrać termin, musisz najpierw wybrać rodzaj cykliczności.',
    toSelectTermSelectDate: 'Aby móc wybrać termin, musisz najpierw wybrać datę. Kliknij przycisk "Wybierz datę".',
    toSelectTermSelectHour: 'Aby móc wybrać termin, musisz najpierw wybrać godzinę. Kliknij przycisk "Wybierz godzinę".',
    twoWeeks: 'Dwa tygodnie',
    typeOfPeriodicityCanBeEditedOnlyInTheFirstReservationOfTheCycle: 'Rodzaju cykliczności nie można edytować w rezerwacjach cyklicznych',
    untilCancel: 'do odwołania',
    untilCancelInfo: 'Ten cykl trwa do odwołania - poniżej prezentowane są najbliższe rezerwacje',
    untilCancelNote: 'System tworzy maksymalnie 30 rezerwacji do przodu. Pamiętaj aby ustawić parametr "Pozwalaj na rezerwacje maksymalnie na X dni do przodu" w opcjach systemu tak, aby nikt nie mógł zarezerwować terminów, które będą wykorzystane do przedłużania cyklu rezerwacji.',
    untilCancelShortNote: 'System tworzy maksymalnie 30 rezerwacji do przodu.',
    updateAllFuturePayments: 'Nadpisz wszystkie przyszłe płatności',
    useAvailableTerm: 'Użyj dostępnego terminu',
    usePricingPrice: 'użyj',
    waitingListReservationTitle: 'Edytowana rezerwacja znajduje się na liście rezerwowej. Czy chcesz podczas zapisu zmienić status tej rezerwacji?',
    waitingListReservationOkBtn: 'Zapisz i zaakceptuj',
    waitingListReservationCancelBtn: 'Pozostaw na liście rezerwowej',
    warning: 'Uwaga!',
    week: 'Tydzień',
    workerForTheServiceWithTermsIsRequired: 'Wybranie pracownika dla usługi z terminami jest wymagane',
    youCanEditServiceOnlyInTheFirstReservationOfTheCycle: 'Usługi nie można edytować w rezerwacjach cyklicznych',
    youEditCancelledReservation: 'Edytowana jest rezerwacją anulowaną. Podczas zapisywania tego formularza będziesz mógł zmienić jej status.',
    youEditRejectedReservation: 'Edytowana jest rezerwacją odrzuconą. Podczas zapisywania tego formularza będziesz mógł zmienić jej status.',
    youEditReservationWhichWaitsForAccpet: 'Edytowana jest rezerwacją oczekującą na akceptację. Podczas zapisywania tego formularza będziesz mógł zmienić jej status.',
    youEditWaitingListReservation: 'Edytowana rezerwacja jest rezerwacją z listy rezerwowej. Podczas zapisywania tego formularza będziesz mógł zmienić jej status.',
    youMustselectTerm: 'Musisz wybrać termin dla rezerwacji'
  },
  reservationFormCustomHour: {
    selectTerm: 'Wybierz termin:',
    selectTermHour: 'Wybierz godzinę:',
    setTerm: 'Ustaw termin',
    warning: '<strong>Uwaga!</strong> Przy definiowaniu niestandardowego terminu rezerwacji nie są uwzględnianie reguły rezerwacji, dostępność oraz reguły otwarcia.',
    youHaveToSelectDate: 'Musisz wybrać datę'
  },
  reservationFormParams: {
    givenPriceForAdditionalFeatures: 'Podana cena za dodatkowe cechy może się różnić w zależności od zdefiniowanych reguł cen.',
    information: 'Informacja:',
    parameterIsRequired: 'Parametr wymagany',
    selectValue: 'Wybierz wartość',
    thisParameterIsRequired: 'Ten parametr jest wymagany'
  },
  reservationFormTimePopup: {
    select: 'Wybieram',
    selectHour: 'Wybierz godzinę:'
  },
  reservationParameters: {
    addNewParameter: 'Dodaj nowy parametr',
    emptyState: 'Brak zdefiniowanych parametrów rezerwacji...',
    loadingState: 'Trwa ładowanie danych...',
    name: 'Nazwa parametru',
    parametersOrderingChanged: 'Kolejność parametrów rezerwacji została zapisana',
    service: 'Usługa',
    required: 'Wymagany',
    title: 'Parametry rezerwacji',
    type: 'Rodzaj parametru'
  },
  reservationParametersForm: {
    addTitle: 'Dodaj parametr rezerwacji',
    additionalPrice: 'Dodatkowa cena:',
    addParamValue: 'Dodaj wartość parametru',
    affectsPrice: 'Ma wpływ na cenę:',
    checkbox: 'Pole checkbox (multiselect)',
    dropdown: 'Pole select do wyboru',
    editTitle: 'Edytowanie parametru rezerwacji',
    firstSelected: 'Zaznaczaj domyślnie pierwszą wartość',
    infoText: 'Tekst do wyświetlenia',
    inputText: 'Pole tekstowe do wpisania',
    paramAdded: 'Parametr rezerwacji został dodany',
    paramConfigurationChanged: 'Konfiguracja parametru rezerwacji została zmieniona',
    paramName: 'Nazwa parametru:',
    paramContent: 'Treść parametru:',
    paramSettings: 'Ustawienia parametru',
    paramValues: 'Wartości parametru',
    paramValueName: 'Nazwa wartości:',
    paramType: 'Rodzaj parametru:',
    published: 'Opublikowany:',
    publishedOnlyInPanel: 'Opublikowany tylko w panelu:',
    removeParamValue: 'Usuń wartość parametru',
    required: 'Wymagany:',
    servicesTitle: 'Ogranicz parametr do zaznaczonych usług',
    servicesDesc: 'Jeśli nie zaznaczysz żadnej usługi, parametr będzie działać w ramach wszystkich usług',
    textarea: 'Duże pole tekstowe do wpisania',
    valueAdditionalPrice: 'Dodatkowa cena',
    valueName: 'Nazwa wartości',
    youSeeSpecialParamSettings: 'Oglądasz ustawienia parametru specjalnego.'
  },
  reservationParametersListItem: {
    allServices: 'Wszystkie',
    checkboxField: 'Pole checkbox (multiselect)',
    editParameter: 'Edytuj parametr',
    hide: 'Ukryj',
    hideParameter: 'Ukryj parametr',
    infotextField: 'Tekst do wyświetlenia',
    no: 'Nie',
    parameterName: 'Nazwa parametru:',
    parameterType: 'Rodzaj parametru:',
    publish: 'Opublikuj',
    publishParameter: 'Opublikuj parametr',
    removeParameter: 'Usuń parametr',
    removeParamTitle: 'Usuwanie parametru rezerwacji',
    removeParamDesc: 'Czy na pewno chcesz usunąć wybrany parametr rezerwacji?',
    removeParamBtn: 'Usuń parametr',
    required: 'Wymagany:',
    selectField: 'Pole select do wyboru',
    selectedParameterHasBeenRemoved: 'Wybrany parametr rezerwacji został usunięty',
    selectedParameterHasBeenPublished: 'Wybrany parametr został opublikowany',
    selectedParameterHasBeenUnpublished: 'Wybrany parametr został odpublikowany',
    services: 'Usługi:',
    specialParameter: 'Parametr specjalny',
    textareaField: 'Duże pole tekstowe do wpisania',
    textField: 'Pole tekstowe do wpisania',
    thisParameterIsNotPublished: 'Ten parametr nie jest opublikowany',
    thisParameterIsVisibleOnlyInAdminPanel: 'Ten parametr jest widoczny tylko w panelu administracyjnym',
    yes: 'Tak'
  },
  reservationRules: {
    activeRules: 'Aktywne reguły',
    addNewRule: 'Dodaj nową regułę',
    allowMeToAcceptManually: 'pozwól mi akceptować rezerwacje ręcznie',
    automaticallyAccept: 'automatycznie akceptuj rezerwację',
    ifFreeTermsAreAvailableReservationsWillBeAcceptedAutomatically: 'W wypadku wolnych terminów rezerwacje będą od teraz akceptowane automatycznie.',
    ifFreeTermsAreAvailableReservationsWillBeAcceptedManually: 'W wypadku wolnych terminów rezerwacje będą od teraz akceptowane ręcznie.',
    ifReservationIsNotRejectedByRules: 'W sytuacji gdy rezerwacja nie została objęta regułą odrzucenia',
    ifTermIsFree: 'Jeśli termin jest wolny:',
    noReservationRules: 'Nie znaleziono żadnych reguł rezerwacji...',
    ruleDescription: 'Opis działania reguły',
    ruleParams: 'Parametry reguły',
    ruleWorkingMethod: 'Sposób działania reguł',
    title: 'Reguły rezerwacji'
  },
  reservationRulesForm: {
    addTitle: 'Dodawanie reguły rezerwacji',
    allPersons: 'wszystkie osoby (z dodawaną rezerwacją)',
    applyToService: 'Zastosuj do usługi:',
    biggerThan: 'większa od',
    configurationTitle: 'Konfiguracja reguły rezerwacji',
    editTitle: 'Edycja reguły rezerwacji',
    numberOfConfirmedReservationsBiggerThan: 'Liczba potwierdzonych rezerwacji większa od:',
    numberOfPeopleCountedAs: 'Liczba osób liczona jako:',
    numberOfPeoplePerOneTerm: 'Liczba osób na jeden termin',
    numberOfReservationsPerOneTerm: 'Liczba rezerwacji na jeden termin',
    rejectReservationWhen: 'Odrzucaj rezerwację gdy:',
    reservationRuleAdded: 'Reguła rezerwacji została dodana',
    reservationRuleDataChanged: 'Dane reguły rezerwacji zostały zmienione',
    singleReservation: 'pojedyncza istniejąca rezerwacja',
    smallerThan: 'mniejsza od'
  },
  reservationRulesListItem: {
    action: 'Akcja:',
    biggerThan: ' większa od ',
    countOfConfirmedReservations: 'Liczba potwierdzonych rezerwacji: ',
    defaultRuleDescription: '<p><strong>Pracownik:</strong> Brak wolnych pracowników</p><p><strong>Akcja:</strong> Odrzuć rezerwację</p>',
    editRule: 'Edytuj regułę',
    everyWorkerHasAReservationLimit: 'Każdy pracownik posiada limit liczby rezerwacji na <strong>jeden termin</strong>, który można zmienić w ustawieniach profilu pracownika. Domyślny limit to maksymalnie <strong>1 rezerwacja</strong> na jeden termin.',
    lesserThan: ' mniejsza od ',
    oneTermMaxAmountOfReservations: 'Na jeden termin przyjmujesz maksymalnie ',
    oneTermOneReservation: 'Na jeden termin przyjmujesz maksymalnie <strong>jedną rezerwację</strong>',
    rejectReservation: 'Odrzuć rezerwację',
    removeReservationRuleTitle: 'Usuwanie reguły rezerwacji',
    removeReservationRuleDesc: 'Czy na pewno chcesz usunąć wybraną regułę rezerwacji?',
    removeReservationRuleBtn: 'Usuń regułę',
    removedReservationRule: 'Wybrana reguła została usunięta',
    removeRule: 'Usuń regułę',
    reservationWillBeRejectedIf1: 'Rezerwacja zostanie odrzucona gdy na wybrany termin suma liczby osób rezerwacji potwierdzonych oraz liczby osób podanej w formularzu będzie ',
    reservationWillBeRejectedIf2: 'Rezerwacja zostanie odrzucona gdy na wybrany termin posiadasz potwierdzoną przynajmniej jedną, pojedynczą rezerwację dla liczby osób ',
    ruleDescriptionAllPeopleCount: '<p><strong>Liczba osób (wszystkie osoby):</strong>',
    ruleDescriptionPeopleCountSingleReservation: '<p><strong>Liczba osób (pojedyncza istniejąca rezerwacja):</strong>'
  },
  reservationRulesProblemPopup: {
    noFreeWorkersTitle: 'Brak wolnych pracowników',
    noFreeWorkersDesc: '<p>W tym terminie brakuje wolnych pracowników.</p>',
    noFreeWorkersOkButton: 'Edytuj rezerwację',
    noFreeWorkersCancelButton: 'Odrzuć rezerwację',
    reservationNotMeetRulesTitle: 'Rezerwacja nie spełnia reguł',
    reservationNotMeetRulesDesc: '<p>Rezerwacja nie spełnia następujących reguł rezerwacji:</p>',
    reservationNotMeetRulesOkButton: 'Edytuj rezerwację',
    reservationNotMeetRulesCancelButton: 'Odrzuć rezerwację',
    selectedWorkerIsUnavailableTitle: 'Wybrany pracownik jest niedostępny',
    selectedWorkerIsUnavailableDesc: '<p>W tym terminie wybrany pracownik nie jest dostępny. Wybierz innego pracownika z poniższej listy:</p>',
    selectedWorkerIsUnavailableOkButton: 'Zmień pracownika i zaakceptuj',
    selectedWorkerIsUnavailableCancelButton: 'Odrzuć rezerwację',
    selectWorker: 'Wybierz pracownika'
  },
  reservationStatus: {
    cancelled: 'Anulowane',
    clientNotPresent: 'Klient nieobecny',
    confirmed: 'Potwierdzone',
    newRequest: 'Nowe zapytanie',
    rejected: 'Odrzucone',
    waitingList: 'Lista rezerwowa'
  },
  reservationStatusChange: {
    cancelReservationTitle: 'Anulowanie rezerwacji',
    cancelCyclicReservation: 'Wybrana rezerwacja jest cykliczna. Anulować tylko tę rezerwację, czy anulować ją razem z wszystkimi przyszłymi rezerwacjami z cyklu?',
    cancelAll: 'Anuluj wszystkie',
    cancelOnlyThisOne: 'Anuluj tylko tę rezerwację',
    cancelReservation: 'Anuluj rezerwację',
    checkDuplicatedReservation: 'Podobna rezerwacja to <a href="{url}">#{id}</a>',
    dateUnblocked: 'Wybrany termin został odblokowany',
    doYouWantCancelReservation: 'Czy chcesz anulować tę rezerwację?',
    doYouWantToRejectRequest: 'Czy chcesz odrzucić to zapytanie o termin?',
    notifyAboutFreeTerm: 'Czy powiadomić poniższe osoby o wolnym terminie?',
    okContinue: 'Tak, zapisz',
    rejectReservationTitle: 'Odrzucanie rezerwacji',
    rejectCyclicReservation: 'Wybrana rezerwacja jest cykliczna. Odrzucić tylko tę rezerwację, czy odrzucić ją razem z wszystkimi przyszłymi rezerwacjami z cyklu?',
    rejectAll: 'Odrzuć wszystkie',
    rejectOnlyThisOne: 'Odrzuć tylko tę rezerwację',
    rejectRequest: 'Odrzuć zapytanie',
    rejectRequestTitle: 'Odrzucenie zapytania',
    reservationAccepted: 'Rezerwacja została zaakceptowana',
    reservationCancelled: 'Rezerwacja została anulowana',
    reservationCancelledNotificationsSent: 'Rezerwacja została anulowana, powiadomienia zostały wysłane',
    reservationRejected: 'Rezerwacja została odrzucona',
    reservationRejectedNotificationsSent: 'Rezerwacja została odrzucona, powiadomienia zostały wysłane',
    requestRejectedWithWaitingListTitle: 'Odrzucenie zapytania',
    requestRejectedWithWaitingListDesc: 'Chcesz odrzucić to zapytanie o termin czy dodać je do listy rezerwowej?',
    requestRejectedWithWaitingListCancelButton: 'Odrzucenie zapytania',
    requestRejectedWithWaitingListOkButton: 'Dodanie do listy rezerwowej',
    requestRejectedDesc: 'Czy chcesz odrzucić to zapytanie o termin?',
    requestRejectedTitle: 'Odrzucenie zapytania',
    unblockDate: 'Odblokuj termin',
    unblockDateTitle: 'Odblokowanie terminu',
    unblockDateDesc: 'Wybrana blokada terminu jest cykliczna. Odblokować tylko ten termin, czy odblokować go razem z wszystkimi przyszłymi blokadami z cyklu?',
    unblockDateCancelBtn: 'Odblokuj wszystkie',
    unblockDateOkBtn: 'Odblokuj tylko ten termin',
    unblockDate2Title: 'Odblokowanie terminu',
    unblockDate2Desc: 'Czy chcesz odblokować ten termin?',
    unblockDate2Btn: 'Odblokuj termin',
    yesNotify: 'Tak, powiadom!',
    youHaveWaitingList: 'Posiadasz listę rezerwową na wybrany termin'
  },
  searchDateForm: {
    addReservation: 'Rezerwacja',
    anyWorker: 'Dowolny pracownik',
    blockDate: 'Zablokuj',
    blockReservationDate: 'Zablokuj termin',
    checkTerm: 'Szukaj wolnego terminu',
    cyclicReservation: 'Cykliczna do odwołania',
    cyclicType: 'Rodzaj cykliczności:',
    duration: 'Czas trwania:',
    durationMustBeBiggerThanZero: 'Czas trwania usługi musi być większy od zera',
    estimatedTimeForService: 'Szacowany czas dla wybranej usługi to:',
    foundedFreeWorkers1: 'Znaleziono jednego dostępnego pracownika:',
    foundedFreeWorkersN: 'Znaleziono {count} dostępnych pracowników:',
    loadingTerms: 'Trwa ładowanie terminów...',
    nearestPossibleTerms: 'Najbliższe możliwe terminy',
    noFreeTermsForSelectedService: 'Brak wolnych terminów dla wybranej usługi',
    oneTime: '1 raz',
    or: 'lub',
    packageReservation: 'Pakiet rezerwacji',
    provideCorrectPeopleNumber: 'Podaj poprawną liczbę osób',
    provideProperChildrenNumber: 'Podaj poprawną liczbę dzieci',
    provideProperDaysNumber: 'Podaj poprawną liczbę dni',
    repeatEvery: 'Powtarzaj co:',
    repeatEveryDay: 'Dzień',
    repeatEveryWeek: 'Tydzień',
    repeatEveryTwoWeeks: 'Dwa tygodnie',
    repeatEveryFourWeeks: 'Cztery tygodnie',
    reservationType: 'Rodzaj rezerwacji:',
    searchSinceDay: 'Szukaj od dnia:',
    select: 'Wybierz',
    selectCyclicType: 'Wybierz rodzaj cykliczności',
    selectDate: 'Wybierz datę',
    selectHour: 'Wybierz godzinę',
    selectMonth: 'Wybierz miesiąc',
    selectTerm: 'Wybierz termin',
    selectWorker: 'Wybierz pracownika:',
    serviceIsRequired: 'Wybranie usługi jest wymagane',
    showTerms: 'Pokaż terminy',
    singleReservation: 'Rezerwacja pojedyncza',
    times: 'razy',
    thisListShowsAtMax30Results: 'Poniższa lista prezentuje maksymalnie 30 najbliższych terminów.',
    toSelectTermSelectCyclicType: 'Aby móc wybrać termin, musisz najpierw wybrać rodzaj cykliczności.',
    toSelectTermSelectDate: 'Aby móc wybrać termin, musisz najpierw wybrać datę. Kliknij przycisk "Wybierz datę".',
    toSelectTermSelectHour: 'Aby móc wybrać termin, musisz najpierw wybrać godzinę. Kliknij przycisk "Wybierz godzinę".',
    toSelectTermSelectService: 'Aby móc wybrać termin, musisz najpierw wybrać usługę.',
    warning: 'Uwaga!',
    youMustSelectCyclicType: 'Należy wybrać rodzaj cykliczności',
    youMustSelectTermForReservation: 'Musisz wybrać termin dla rezerwacji',
    youMustSelectWorkerForServiceWithTerms: 'Wybranie pracownika dla usługi z terminami jest wymagane'
  },
  searchPopup: {
    insertNamePhoneOrEmail: 'Wpisz imię, nazwisko, telefon lub adres e-mail:',
    loadingResults: 'Trwa ładowanie wyników...',
    noResultsForGivenPhrase: 'Nie znaleziono rezerwacji pasujących do podanej frazy...',
    title: 'Szukaj rezerwacji'
  },
  searchPopupReservation: {
    cancelReservation: 'Anuluj rezerwację',
    cancelReservationTitle: 'Anulowanie rezerwacji',
    cancelReservationDesc: 'Wybrana rezerwacja jest cykliczna. Anulować tylko tę rezerwację, czy anulować ją razem z wszystkimi przyszłymi rezerwacjami z cyklu?',
    cancelReservationDesc2: 'Czy chcesz anulować tę rezerwację?',
    cancelReservationCancelButton: 'Anuluj wszystkie',
    cancelReservationOkButton: 'Anuluj tylko tę rezerwację',
    cancelReservationOkButton2: 'Anuluj rezerwację',
    cardRegistered: 'Karta zarejestrowana',
    clientNotPresent: 'Klient się nie pojawił',
    clientNotPresentTitle: 'Klient nie przyszedł?',
    clientNotPresentDesc: 'Jeśli klient nie pojawił się, kliknij przycisk Tak, aby zanotować to w jego statystykach.',
    clientNotPresentOkButton: 'Tak, klient się nie pojawił',
    clientSavedAsNotPresent: 'Zapisano nieobecność klienta',
    category: 'Kategoria: ',
    emailPrefix: 'email: ',
    paid: 'Zapłacone',
    phonePrefix: 'tel: ',
    readMoreAboutReservation: 'Dowiedz się więcej o rezerwacji',
    reservationCancelled: 'Rezerwacja została anulowana',
    reservationCancelledNotificationsSent: 'Rezerwacja została anulowana, powiadomienia zostały wysłane',
    unpaid: 'Niezapłacone',
    youHaveWaitingListTitle: 'Posiadasz listę rezerwową na wybrany termin',
    youHaveWaitingListDesc: 'Czy powiadomić poniższe osoby o wolnym terminie?<br>',
    youHaveWaitingListOkButton: 'Tak, powiadom!'
  },
  services: {
    addCategory: 'Dodaj kategorię',
    addNewCategory: 'Dodaj nową kategorię',
    addNewService: 'Dodaj nową usługę',
    categoryAdded: 'Kategoria została dodana',
    categoryChanged: 'Kategoria została zmieniona',
    categories: 'Kategorie',
    categoryID0: 'ID kategorii: 0',
    categoryID: 'ID kategorii: ',
    categoryOrderingSaved: 'Kolejność kategorii usług została zapisana',
    categoryRemoved: 'Kategoria została usunięta',
    duration: 'Czas trwania',
    editCategory: 'Edytuj kategorię',
    editCategoryName: 'Edytuj nazwę kategorii',
    emptyState: 'Brak usług w tej kategorii',
    listOfAvailableServices: 'Lista dostępnych usług',
    name: 'Nazwa usługi',
    payments: 'Płatności',
    removeCategory: 'Usuń kategorię',
    removingCategoryTitle: 'Usuwanie kategorii',
    removingCategoryDesc: 'Czy na pewno chcesz usunąć wybraną kategorię? Usługi z tej kategorii zostaną przypisane do grupy usług bez kategorii.',
    removingCategoryBtn: 'Usuń kategorię',
    servicesOrderingSaved: 'Kolejność usług została zapisana',
    serviceType: 'Rodzaj usługi',
    title: 'Usługi'
  },
  serviceCategoryPrompt: {
    andAllLanguageVersions: ' i wszystkie wersje językowe dla tej kategorii',
    setCategoryName: 'Podaj nazwę kategorii'
  },
  serviceListItem: {
    constantService: 'Usługa stała',
    customerDecide: 'Określa klient',
    daysService: 'Rezerwacje na dni',
    duration: 'Czas trwania:',
    editService: 'Edytuj usługę',
    hide: 'Ukryj',
    hideService: 'Ukryj usługę',
    minutes: ' min',
    no: 'Nie',
    notRelated: 'n/d',
    payments: 'Płatności:',
    periodicalService: 'Usługa okresowa',
    publish: 'Opublikuj',
    publishService: 'Opublikuj usługę',
    removingServiceTitle: 'Usuwanie usługi',
    removingServiceDesc: 'Czy na pewno chcesz usunąć wybraną usługę?',
    removingServiceBtn: 'Usuń usługę',
    removeService: 'Usuń usługę',
    selectedServiceCopied: 'Wybrana usługa została skopiowana',
    selectedServicePublished: 'Wybrana usługa została opublikowana',
    selectedServiceRemoved: 'Wybrana usługa została usunięta',
    selectedServiceUnpublished: 'Wybrana usługa została odpublikowana',
    serviceType: 'Rodzaj usługi:',
    termService: 'Usługa terminowa',
    thisServiceIsHidden: 'Ta usługa jest ukryta',
    thisServiceIsTrashed: 'Ta usługa została usunięta',
    tooltipNoWorkersForService: 'Brak pracowników przypisanych do usługi\nID usługi: {serviceID}',
    tooltipService: 'ID usługi: {serviceID}',
    yes: 'Tak'
  },
  servicesForm: {
    accordingToDurationTimes: '(według czasów trwania)',
    addCycle: 'Dodaj pakiet',
    addDuration: 'Dodaj czas trwania',
    addTerm: 'Dodaj termin',
    allowDurationSelection: 'Pozwól wybrać czas trwania:',
    availabilityDuringTheWeek: 'Dostępność usługi w tygodniu',
    category: 'Kategoria:',
    childrenPrice: 'Dodatkowa cena za dzieci:',
    color: 'Kolor:',
    constantService: 'Usługa stała',
    createQRTicketsForReservations: 'Twórz bilety QR do rezerwacji:',
    dailyEndAvailable: 'Wybierz rodzaj rezerwacji na dni',
    dailyEndAvailableDays: 'Rezerwacje na pełne dni',
    dailyEndAvailableNights: 'Rezerwacje na doby',
    dailyEndAvailableDescription: 'Gdy wybrane są rezerwacje na doby, oznacza to, że zasób jest zwalniany w ciągu dnia po ostatniej nocy. Przykład: jeśli doba najmu kończy się o 12:00 a nastepna doba najmu zaczyna się tego samego dnia (np. o 15:00) sugerujemy włączenie tej opcji dla usługi.',
    day: 'Dzień',
    daysService: 'Rezerwacje na dni',
    duration: 'Czas trwania:',
    durationTimes: 'Czasy trwania',
    durationsListName: 'Nazwa',
    durationsListTime: 'Czas trwania (min.)',
    durationsListPrice: 'Cena',
    emailNotification: 'Dodatkowy tekst w powiadomieniu e-mail:',
    emptyState: 'Brak terminów dla tej usługi',
    emptyStateForDurations: 'Brak czasów trwania dla tej usługi',
    emptyStateForPeriodicity: 'Brak pakietów rezerwacji dla tej usługi',
    forAll: 'za całość',
    forReservation: 'za rezerwację',
    fourWeeks: 'Cztery tygodnie',
    getResponseTitle: 'Integracja z GetResponse',
    googleMeet: 'Twórz spotkanie Google Meet w momencie dodania rezerwacji',
    hideService: 'Ukryj usługę:',
    hiddenServicesAreVisibleOnlyInAdminPanel: 'Usługi ukryte są widoczne tylko w panelu administracyjnym',
    ifThisOptionIsEnabledTheDropdownAppear: 'Włączając tę opcję, pole liczba osób na formularzu pojawi się jako lista wyboru z możliwością określenia wartości pomiędzy maksymalną i minimalną liczbą osób',
    invoicesTitle: 'Ustawienia na fakturze (Fakturownia)',
    limitNumberOfPeoplePerOneReservation: 'Ogranicz liczbę osób na jedną rezerwację:',
    maximumPeopleNumberMustBeBiggerEqualToMinimalPeopleNumber: 'Maksymalna liczba osób musi być większa lub równa minimalnej liczbie osób',
    maximalPeopleNumber: 'Maksymalna liczba osób:',
    minimalPeopleNumber: 'Minimalna liczba osób:',
    name: 'Nazwa:',
    offsetsAsServiceDurationTime: 'Odstępy takie jak czas trwania usługi',
    offsetsDuringHourSelection: 'Odstępy czasu przy wyborze godziny rezerwacji:',
    paymentMethodsForTheService: 'Metody płatności za usługę',
    periodicity: 'Pakiety rezerwacji:',
    periodicityListName: 'Nazwa',
    periodicityListPrice: 'Cena',
    periodicityRepeat: 'Powtarzaj co',
    periodicalService: 'Usługa okresowa (definiuje godziny dostępności)',
    periodicityPaymentType: 'Rodzaj płatności cyklicznych',
    periodicityPaymentTypePackage: 'Płatność za pakiet',
    periodicityPaymentTypeSingle: 'Płatność za pojedynczą rezerwację',
    periodicityDaysPaymentReminder: 'Wysyłaj link do płatności na X dni przed rezerwacją',
    periodicityDaysPaymentReminderNote: 'Jeśli liczba dni wynosi 0, linki do płatności nie będą wysyłane',
    periodicityDaysPaymentReminderFor: 'Płatność z góry za X rezerwacji',
    periodicityDaysPaymentReminderForNote: 'Jeśli liczba rezerwacji jest większa od 1 będzie wysyłany link do płatności za X kolejnych rezerwacji. Np. gdy X=2 co 2 rezerwacje będzie wysyłany link do płatnosci za kolejne 2 rezerwacje.',
    periodicityHoursPaymentCancel: 'Anuluj rezerwacje na X godzin przed rezerwacją w przypadku braku płatności',
    periodicityHoursPaymentCancelNote: 'Jeśli liczba godzin wynosi 0, rezerwację nigdy nie będą anulowane',
    periodicityFirstPayment: 'Wymagaj płatności za pierwszą rezerwację w momencie rezerwacji',
    periodicityFirstPaymentCancelNote: '<strong>Uwaga!</strong> Pierwsza płatność musi być dokonana w czasie zgodnym z konfiguracją używanej metody płatności. <br>Brak płatności anuluje cały cykl.',
    removeCycle: 'Usuń pakiet',
    removeDuration: 'Usuń czas trwania',
    removeTerm: 'Usuń termin',
    requiresChildrenNumber: 'Dodatkowa liczba dla dzieci:',
    requiresFiveMultiplication: 'Wymagana jest wielokrotność 5 minut',
    requiresPayment: 'Wymaga płatności:',
    requiresPeopleNumber: 'Wymaga podania liczby osób:',
    serviceChanged: 'Dane usługi zostały zmienione',
    serviceData: 'Dane usługi',
    serviceHasBeenAdded: 'Usługa została dodana',
    servicePrice: 'Cena usługi:',
    serviceTermsList: 'Lista terminów usługi',
    serviceType: 'Rodzaj usługi:',
    termService: 'Usługa terminowa (event)',
    termsListName: 'Nazwa',
    termsListDate: 'Data',
    termsListHour: 'Godzina',
    thisServiceWillSupportDays: 'Ta usługa będzie mogła być rezerwowana na dni',
    thisServiceWillSupportHours: 'Ta usługa będzie mogła być rezerwowana na godziny',
    titleAdd: 'Dodawanie usługi',
    titleEdit: 'Edycja usługi',
    twoWeeks: 'Dwa tygodnie',
    qrTicketAdditionalInformation: 'Dodatkowe informacje na bilecie:',
    youMustToSpecifyAtLeastOneTermForThisService: 'Musisz określić co najmniej jeden termin dla tej usługi',
    youMustToSpecifyHourForallCreatedTerms: 'Należy określić godzinę dla wszystkich utworzonych terminów dla tej usługi',
    youMustSpecifyAtLeastOneDurationTime: 'Musisz zdefiniować co najmniej jeden czas trwania',
    youMustDefineAtLeastOneCycle: 'Musisz zdefiniować co najmniej jeden cykl',
    youMustSpecifiyValidNumberOfDays: 'Należy określić prawidłową liczbę dni',
    youMustSpecifiyValidNumberOfHours: 'Należy określić prawidłową liczbę godzin',
    youMustSpecifiyValidNumberOfReservations: 'Należy określić prawidłową liczbę rezerwacji',
    week: 'Tydzień',
    withoutCategory: 'Bez kategorii',
    workersDoingService: 'Pracownicy wykonujący usługę'
  },
  settings: {
    main: {
      additionalFunctions: 'Dodatkowe funkcje systemu',
      adjustFunction: 'Dostosuj funkcję',
      availableIntegrations: 'Dostępne integracje',
      basicFunctions: 'Podstawowe funkcje systemu',
      buyHigherPackage: 'Kup wyższy pakiet',
      dailyReservationsTitle: 'Rezerwacje na dni',
      dailyReservationsDesc: 'Pozwala na przyjmowanie rezerwacji na dni',
      emails: 'Powiadomienia e-mail',
      gdpr: 'RODO',
      myPageTitle: 'Moja strona WWW',
      myPageDesc: 'Daje możliwość stworzenia własnej strony internetowej',
      servicesTitle: 'Usługi',
      servicesDesc: 'Sprecyzowanie konkretnych usług dla danej rezerwacji',
      reservationParamsTitle: 'Parametry rezerwacji',
      reservationParamsDesc: 'Dostosowywanie dodatkowych parametrów w rezerwacjach',
      smsTitle: 'Powiadomienia SMS',
      smsDesc: 'Wysyłanie powiadomień SMS dotyczących rezerwacji',
      paymentsTitle: 'Płatność za rezerwację',
      paymentsDesc: 'Pobieranie opłat za dokonanie rezerwacji',
      workersTitle: 'Pracownicy',
      workersDesc: 'Przypisywanie konkretnych pracowników do usług i rezerwacji',
      googleCalendarTitle: 'Integracja z kalendarzem Google',
      googleCalendarDesc: 'Podgląd rezerwacji bezpośrednio w kalendarzu Google. <strong>Uwaga!</strong> Ta opcja nie może być włączona wraz z integracją z kalendarzem Outlook.',
      outlookCalendarTitle: 'Integracja z kalendarzem Outlook',
      outlookCalendarDesc: 'Podgląd rezerwacji bezpośrednio w kalendarzu Outlook. <strong>Uwaga!</strong> Ta opcja nie może być włączona wraz z integracją z kalendarzem Google.',
      getResponseTitle: 'Integracja z GetResponse',
      getResponseDesc: 'Możliwość powiązania usług z listami w GetResponse.',
      fakturowniaTitle: 'Integracja z Fakturownia',
      fakturowniaDesc: 'Możliwość wystawiania oraz pobierania faktur z poziomu panelu Bookero.',
      multilanguageTitle: 'Wielojęzyczność',
      multilanguageDesc: 'Możliwość ustawienia dodatkowych języków w formularzu rezerwacji i stronie WWW',
      plugin: 'Wtyczka',
      reservations: 'Rezerwacje',
      settingsSaved: 'Ustawienia zostały zapisane',
      thisFunctionHasRequirements: 'Ta funkcja wymaga włączonych usług',
      thisFunctionHasRequirementPayment: 'Ta funkcja wymaga włączonych płatności',
      title: 'Ustawienia'
    },
    multilanguage: {
      additionalLanguages: 'Wybierz dodatkowe języki, które chcesz wykorzystywać',
      language: 'Język',
      settingsSaved: 'Ustawienia wielojęzyczności zostały zmienione',
      title: 'Ustawienia wielojęzyczności'
    }
  },
  settingsBasicBlock: {
    changeSettings: 'Zmień ustawienia'
  },
  settingsEmails: {
    actionButtonBgColor: 'Kolor tła przycisku akcji:',
    actionButtonFontColor: 'Kolor czcionki przycisku akcji:',
    address: 'Adres:',
    addressButtonBgColor: 'Kolor tła przycisku adresu:',
    addressButtonFontColor: 'Kolor czcionki przycisku adresu:',
    bgColor: 'Kolor tła:',
    bgOfRequiredActionInfo: 'Kolor tła informacji o wymaganej akcji:',
    buttonText: 'Tekst przycisku:',
    city: 'Miejscowość:',
    companyNameFontSize: 'Rozmiar nazwy firmy:',
    companyNameColor: 'Kolor nazwy firmy:',
    defaultSettings: 'Ustawienia domyślne',
    defaultSettingsRestored: 'Ustawienia domyślne zostały przywrócone',
    defaultSettingsNotRestored: 'Nie udało się przywrócić ustawień domyślnych.',
    emailHasBeenSent: 'E-mail został wysłany',
    emailNotSent: 'Nie udalo się wysłać wiadomości e-mail',
    emailTitle: 'Tytuł maila:',
    fontSizeForInfo: 'Rozmiar czcionki informacji:',
    fontColorForInfo: 'Kolor czcionki informacji:',
    fontSizeForPrice: 'Rozmiar czcionki ceny:',
    fontSize: 'Rozmiar tekstu:',
    fontSizeXS: 'Bardzo mały tekst',
    fontSizeS: 'Mały tekst',
    fontSizeM: 'Normalny tekst',
    fontSizeL: 'Duży tekst',
    fontSizeXL: 'Bardzo duży tekst',
    generalSettings: 'Ustawienia ogólne',
    hours2: '2 godziny',
    hours3: '3 godziny',
    hours4: '4 godziny',
    hours5: '5 godzin',
    hours6: '6 godzin',
    hours7: '7 godzin',
    hours8: '8 godzin',
    hours9: '9 godzin',
    hours10: '10 godzin',
    hours11: '11 godzin',
    hours12: '12 godzin',
    hours24: '24 godziny',
    hours48: '48 godzin',
    hours72: '72 godziny',
    image: 'Grafika:',
    leaveEmptyToHideButton: 'Pozostaw to pole pustym aby ukryć przycisk',
    mainFontSize: 'Główny rozmiar czcionki:',
    mainTextColor: 'Główny kolor czcionki:',
    minutes15: '15 minut',
    minutes30: '30 minut',
    minutes45: '45 minut',
    minutes60: '60 minut',
    minutes75: '75 minut',
    minutes90: '90 minut',
    notSendReminder: 'Nie wysyłaj przypomnienia',
    paymentButtonText: 'Tekst przycisku:',
    priceFontColor: 'Kolor czcionki ceny:',
    restoreDefaultSettingsTitle: 'Przywracanie ustawień domyślnych',
    restoreDefaultSettingsDesc: 'Czy na pewno chcesz przywrócić ustawienia domyślne? Wszystkie zmiany w ustawieniach ogólnych i szablonach maili zostaną utracone po zapisaniu zmian.',
    restoreDefaultSettingsBtn: 'Przywróć',
    restoreDefaultSettings: 'Przywróć ustawienia domyślne',
    removeImage: 'Usuń grafikę',
    seePreview: 'Zobacz podgląd',
    seeSettings: 'Zobacz ustawienia',
    selectLanguage: 'Wybierz język:',
    selectTemplate: 'Wybierz szablon:',
    sendICS: 'Załączaj pliki ICS:',
    sendReminderBeforeReservation: 'Wyślij <strong>przypomnienie</strong> przed rezerwacją:',
    sendTestEmail: 'Wyślij e-mail testowy',
    sendingTestEmail: 'Wysyłanie wiadomości testowej',
    settingsSaved: 'Ustawienia powiadomień e-mail zostały zmienione',
    showCancelButton: 'Pokaż przycisk anulowania:',
    showReservationDetails: 'Pokaż szczegóły rezerwacji:',
    showReservationParams: 'Pokaż parametry rezerwacji:',
    showPeopleNumber: 'Pokaż liczbę osób:',
    showQuote: 'Pokaż sumę do zapłaty:',
    showWorker: 'Pokaż pracownika',
    showTravelTips: 'Pokaż jak dojechać:',
    templates: 'Szablony wiadomości',
    templateSettings: 'Ustawienia szablonów wiadomości',
    templateAccepted: 'Rezerwacja zaakceptowana',
    templateCancelled: 'Rezerwacja anulowana',
    templateChangeTerm: 'Zmiana terminu rezerwacji',
    templateCartchanged: 'Zmiana statusu koszyka',
    templateChangePaymentStatus: 'Zmiana statusu płatności przez firmę',
    templateMissingPayment: 'Brak płatności',
    templatePaid: 'Rezerwacja opłacona',
    templateRejected: 'Rezerwacja odrzucona',
    templateReminder: 'Przypomnienie rezerwacji',
    templateSurvey: 'Prośba o wypełnienie ankiety',
    templateTerm: 'Zwolnił się termin',
    templateUnpaid: 'Oczekuje na płatność',
    templateWaitingList: 'Przypisanie do listy rezerwowej',
    testEmailAddress: 'Testowy adres e-mail',
    textBeforeReservationDetails: 'Treść maila przed szczegółami rezerwacji:',
    textUnderReservationDetails: 'Treść maila pod szczegółami rezerwacji:',
    title: 'Ustawienia powiadomień e-mail',
    toTestEmaiPleaseSaveChanges: 'Aby przetestować swoje zmiany w wysyłanym mailu testowym, pamiętaj o zapisaniu zmian przed jego wysyłką.',
    uploadFileToChangeImage: 'Wyślij nowy plik by zmienić grafikę',
    useNewTemplates: 'Używaj nowych szablonów:',
    warning: 'Uwaga!',
    week1: '1 tydzień',
    week2: '2 tygodnie',
    week3: '3 tygodnie',
    weHaveAddedNewTemplates: 'Dodaliśmy możliwość włączenia nowych, przeprojektowanych szablonów mailowych. Możesz je włączyć w ustawieniach ogólnych.'
  },
  settingsGdpr: {
    additionalGdprText: 'Do treści zostanie automatycznie dodany tekst: „Szczegóły znajdziesz w polityce prywatności”. Polityka prywatności zostanie automatycznie podlinkowana.',
    agreementsTitle: 'Konfiguracja zgód',
    dataRetentionTitle: 'Ustawienia retencji danych',
    documentsTitle: 'Przydatne dokumenty',
    downloadDocument: 'Pobierz dokument',
    emailAgreementText: 'Treść zgody na przetwarzanie danych w celach marketingowych z wykorzystaniem wiadomości e-mail:',
    gdprDisclaimer: '<strong>UWAGA!</strong> Powyższe dokumenty stanowią wzory, z których możesz korzystać w dowolny sposób. Możesz zmieniać oraz modyfikować dokumenty. SAFI STUDIO Paweł Nowakowski, ul. Spacerowa 25, 05-152 Czosnów, NIP: 531-161-08-55 jako właściciel systemu Bookero nie odpowiada za nienależyte lub nieprawidłowe wykorzystanie zamieszczonych dokumentów.',
    gdprInfoText: 'Treść skróconego obowiązku informacyjnego:',
    gdprUrl: 'Adres URL do klauzuli o obowiązku informacyjnym:',
    getAgreementsForEmails: 'Zbieraj zgody na działania marketingowe z wykorzystaniem wiadomości e-mail:',
    getAgreementsForSupport: 'Zezwalam na dostęp do danych osobowych na potrzeby pomocy przez Support Bookero.',
    getAggrementsForSupportNote: 'Zgoda udzielona tylko na potrzeby rozwiązywania zgłoszonych problemów.',
    getAgreementsForPhoneCalls: 'Zbieraj zgody na działania marketingowe z wykorzystaniem połączeń telefonicznych:',
    ifItIsEnabledYouHaveToProvideAtLeastOneUrl: 'Jeżeli ta opcja jest zaznaczona, należy wypełnić co najmniej jeden z powyższych adresów: polityki prywatności i/lub regulaminu.',
    ifInformationAgreeIsEnabledThisCannotBeEmpty: 'Należy wypełnić to pole, jeśli pokazywanie skróconej wersji obowiązku informacyjnego jest włączone',
    phoneCallsAgreementText: 'Treść zgody na przetwarzanie danych w celach marketingowych z wykorzystaniem połączeń telefonicznych:',
    privacyPolicyUrl: 'Adres URL do polityki prywatności:',
    removeDataNote: 'Podczas usuwania rezerwacji pomijane są pierwsze rezerwacje z cyklów oraz pakietów, dopóki jest jeszcze jakaś połączona przyszła rezerwacja',
    removeDataAfterDaysReservations: 'Po ilu dniach od terminu rezerwacji usuwać dane?',
    removeDataAfterDaysCustomerAndReservations: 'Po ilu dniach nieaktywności usuwać klienta i jego rezerwacje?',
    removeDataAfterDaysCustomerAndReservationsNote: 'Jeśli klient nie doda nowej rezerwacji w określonym czasie, jego dane wraz z rezerwacjami zostaną usunięte. <strong>Rezerwacje, które nie posiadają przypisanych klientów, NIE BĘDĄ usuwane.</strong>',
    removeDataAfterDaysCustomerAndReservationsNoteAlt: 'Jeśli klient nie doda nowej rezerwacji w określonym czasie, jego dane wraz z rezerwacjami zostaną usunięte. <strong class="is-invalid">Rezerwacje, które nie posiadają przypisanych klientów, BĘDĄ usuwane</strong>.',
    removeDataByAgree: 'Nie usuwaj danych klienta i rezerwacji, jeśli klient wyraził jakąkolwiek zgodę marketingową',
    removeDataWithoutCustomer: 'Usuwaj rezerwacje nieprzypisane do żadnego klienta',
    removeDataWithoutCustomerDesc: 'Jeśli rezerwacja została przypisana do klienta, który już nie istnieje, zostanie usunięta.',
    removeOldData: 'Usuwaj automatycznie dane z systemu',
    removeOldDataOptions: {
      customersAndReservations: 'Usuwaj dane klientów i rezerwacji',
      notRemove: 'Nie usuwaj',
      onlyReservations: 'Usuwaj tylko dane rezerwacji'
    },
    settingsNotSaved: 'Nie udało się zmienić ustawień RODO. Spróbuj ponownie.',
    settingsSaved: 'Ustawienia RODO zostały zmienione',
    showCheckboxForTosOrPrivacyPolicy: 'Pokaż na formularzu checkbox z akceptacją regulaminu oraz / lub polityki prywatności:',
    showInFormShortGdprInfo: 'Pokaż na formularzu skróconą wersję obowiązku informacyjnego:',
    supportAccessTitle: 'Zgoda na dostęp do konta dla zespołu wsparcia',
    templateForDataProcessing: 'Upoważnienie do przetwarzania danych',
    templateForDPA: 'Wzór umowy powierzenia przetwarzania danych osobowych',
    templateForGdprInfo: 'Wzór pełnego obowiązku informacyjnego',
    templateForImageAgreement: 'Zgoda na wykorzystanie wizerunku',
    templateForRemoteWork: 'Zgoda na pracę zdalną',
    title: 'RODO',
    tosUrl: 'Adres URL do regulaminu strony:',
    valueCannotBeEmpty: 'Ta wartość nie może być pusta',
    valueInvalid: 'Nieprawidłowa wartość - minimalny okres to 1 dzień'
  },
  settingsGoogleCalendar: {
    calendarTitle: 'Konfiguruj integrację z kalendarzem Google',
    connectAccount: 'Połącz konto z kalendarzem Google',
    countOfRepeatingFutureReservations: 'Liczba pobieranych przyszłych rezerwacji powtarzających się',
    deleteConnection: 'Usuń powiązanie z tym kontem',
    enableDuplexIntegration: 'Włącz integrację w dwie strony',
    relatedAccount: 'Powiązane konto',
    removeConnection: 'Usuń powiązanie',
    selectCalendar: 'Wybierz kalendarz',
    servicesTitle: 'Integruj usługi ze swoimi kalendarzami',
    settingsSaved: 'Ustawienia kalendarza Google zostały zmienione',
    title: 'Ustawienia kalendarza Google',
    workerIsIntegratedWithHisAccount: 'Pracownik jest zintegrowany ze swoim kontem Google',
    workersTitle: 'Integruj pracowników ze swoimi kalendarzami',
    youMustToCheckIntegrationBefore: '<strong>Uwaga!</strong> Warto najpierw skonfigurować wszystkie kalendarze oraz sprawdzić integrację w jedną stronę (czyli z Bookero do Google), zanim włączymy integrację w dwie strony.'
  },
  settingsFakturownia: {
    apiToken: 'Token dla API',
    autoEmail: 'Wysyłaj automatycznie dokument po utworzeniu',
    buyerCity: 'Miasto kupującego',
    buyerPostalCode: 'Kod pocztowy kupującego',
    buyerStreet: 'Ulica kupującego',
    buyerTaxID: 'NIP kupującego',
    companyName: 'Nazwa firmy kupującego',
    companyID: 'ID Firmy',
    documentType: 'Rodzaj dokumentu',
    documentTypes: {
      invoice: 'Faktura',
      receipt: 'Paragon'
    },
    emptyServicesList: 'Brak usług dla których można włączyć faktury...',
    enableInvoicesForSelectedServices: 'Włącz faktury dla wybranych usług',
    endpointApiUrl: 'Adres URL dla endpointu API',
    groupCarts: 'Grupuj płatność koszyka rezerwacji do jednej faktury',
    gtuCode: 'Kod GTU',
    hideTaxOnInvoice: 'Ukryj VAT na fakturze (pusta wartość)',
    invoicesRequired: 'Wymagaj danych do faktury',
    integrateOnPayment: 'Integruj automatycznie po otrzymaniu płatności online',
    integrationTitle: 'Konfiguruj integrację z Fakturownia',
    integrationSettingsChanged: 'Ustawienia integracji z Fakturownia zostały zmienione',
    issueReceiptWhenNoInvoice: 'Wystawiaj paragon w przypadku gdy klient nie chce faktury',
    lack: 'Brak',
    mappingParamsTitle: 'Mapowanie parametrów',
    personalInvoiceAsDefault: 'Domyślnie zaznaczaj os. fizyczną przy wyborze odbiorcy faktury',
    serviceTitle: 'Nazwa usługi na fakturze',
    title: 'Ustawienia integracji z Fakturownia',
    vatTax: 'Stawka podatku VAT'
  },
  settingsGetResponse: {
    apiKey: 'Klucz API GetResponse',
    integrationTitle: 'Konfiguruj integrację z GetResponse',
    integrationType: 'Integruj kontakty gdy',
    integrationTypeTocAndPP: 'Wystarczy, że zaznaczono akceptację regulaminu i polityki prywatności',
    integrationTypeNewsletter: 'Wystarczy, że zaznaczono akceptację komunikacji newsletter',
    integrationTypeToCAndNewsletter: 'Zaznaczono akceptację zarówno regulaminu jak i komunikacji newsletter',
    integrationSettingsChanged: 'Ustawienia integracji z GetResponse zostały zmienione',
    listToken: 'Token listy GetResponse',
    selectValue: 'Wybierz opcję',
    title: 'Ustawienia integracji z GetResponse',
    unsubscribeLabel: 'Usuwaj z listy gdy nie spełniono warunków powyżej'
  },
  settingsMyPage: {
    addNewSection: 'Dodaj nową sekcję',
    allChangesSaved: 'Wszystkie zmiany zostały zapisane',
    editSettings: 'Edytuj ustawienia',
    goForward: 'Idź dalej',
    loadingSiteData: 'Ładowanie danych strony...',
    mainDomain: 'bookero.pl',
    noSections: 'Brak sekcji. Utwórz pierwszą sekcję klikając u góry przycisk "Dodaj nową sekcję".',
    orderingSaved: 'Kolejność sekcji została zapisana',
    preview: 'Podgląd strony',
    title: 'Moja strona',
    unsavedChangesTitle: 'Masz niezapisane zmiany',
    unsavedChangesDesc: 'Wykryto niezapisane zmiany w konfiguracji Twojej strony. Klikając przycisk "Idź dalej" utracisz te modyfikacje.'
  },
  settingsOutlookCalendar: {
    calendarTitle: 'Konfiguruj integrację z kalendarzem Outlook',
    connectAccount: 'Połącz konto z kalendarzem Outlook',
    enableDuplexIntegration: 'Włącz integrację w dwie strony',
    relatedAccount: 'Powiązane konto',
    removeAccountConnection: 'Usuń powiązanie z tym kontem',
    removeConnection: 'Usuń powiązanie',
    selectCalendar: 'Wybierz kalendarz',
    servicesTitle: 'Integruj usługi ze swoimi kalendarzami',
    settingsSaved: 'Ustawienia kalendarza Outlook zostały zmienione',
    title: 'Ustawienia kalendarza Outlook',
    workerIsIntegratedWithHisAccount: 'Pracownik jest zintegrowany ze swoim kontem Outlook',
    workersTitle: 'Integruj pracowników ze swoimi kalendarzami',
    youMustToCheckIntegrationBefore: '<strong>Uwaga!</strong> Warto najpierw skonfigurować wszystkie kalendarze oraz sprawdzić integrację w jedną stronę (czyli z Bookero do Outlook), zanim włączymy integrację w dwie strony.'
  },
  settingsPaymentMethodsListItem: {
    changedDefaultPaymentMethod: 'Zmieniono domyślną metodę płatności',
    currency: 'Waluta: ',
    defaultPaymentMethod: 'Domyślna metoda płatności',
    editPaymentMethod: 'Edytuj metodę płatności',
    hiddenMethodCannotBeDefaultPaymentMethod: 'Ukryta metoda nie może być domyślną',
    hide: 'Ukryj',
    hidePaymentMethod: 'Ukryj metodę płatności',
    name: 'Nazwa: ',
    publish: 'Opublikuj',
    publishPaymentMethod: 'Opublikuj metodę płatności',
    removePaymentMethod: 'Usuń metodę płatności',
    removingPaymentMethodTitle: 'Usuwanie metody płatności',
    removingPaymentMethodDesc: 'Czy na pewno chcesz usunąć wybraną metodę płatności?',
    removingPaymentMethodBtn: 'Usuń metodę płatności',
    removedPaymentMethod: 'Wybrana metoda płatności została usunięta',
    selectedPaymentMethodPublished: 'Wybrana metoda płatności została opublikowana',
    selectedPaymentMethodUnpublished: 'Wybrana metoda płatności została odpublikowana',
    services: 'Usługi: ',
    setAsDefaultPaymentMethod: 'Ustaw jako domyślną metodę płatności',
    visibleOnlyForAdmin: 'Ta metoda płatności jest widoczna tylko dla administratora'
  },
  settingsPayments: {
    addMethod: 'Dodaj metodę',
    currency: 'Waluta',
    default: 'Domyślna',
    paymentMethod: 'Metoda płatności',
    paymentMethodDotpay: 'Płatność poprzez Dotpay',
    paymentHotPay: 'Płatność poprzez HotPay',
    paymentMethodIMoje: 'Płatność poprzez imoje',
    paymentMethodPayPal: 'Płatność poprzez PayPal',
    paymentMethodPayU: 'Płatność poprzez PayU',
    paymentMethodPrzelewy24: 'Płatność poprzez Przelewy24',
    paymentMethodsTitle: 'Metody płatności',
    paymentMethodTpay: 'Płatność poprzez Tpay',
    paymentMethodPayNow: 'Płatność poprzez PayNow',
    paymentMethodStripe: 'Płatność poprzez Stripe',
    paymentMethodsOrderingSaved: 'Kolejność metod płatności została zapisana',
    services: 'Usługi',
    title: 'Ustawienia płatności'
  },
  settingsPlugin: {
    blockReservationsFromPlugin: 'Zablokuj możliwość dodawania rezerwacji poprzez wtyczkę',
    byEnablingThisOptionYouWillSplitServiceChoiceToTwoSteps: 'Włączenie tej opcji spowoduje podzielenie wyboru usługi na dwa etapy: wybór kategorii usługi oraz wybór usługi z wybranej kategorii.',
    configureBlockingTitle: 'Konfiguruj blokowanie rezerwacji przez wtyczkę',
    configureTrackingTitle: 'Konfiguruj integracje z usługami analitycznymi',
    configurationTitle: 'Konfiguruj wtyczkę widoczną na stronie',
    disableDefaultWorker: 'Ukryj opcję wyboru dowolnego pracownika',
    enableCart: 'Włącz koszyk rezerwacji',
    functionAvailableOnlyInMonthlyBoxMode: 'Funkcja ta jest dostępna tylko we wtyczce Monthly Box.',
    hideHourChoice: 'Ukryj wybór godziny:',
    leftDateAndTime: 'Zostaw datę i godzinę',
    messageAfterReservationAccept: 'Treść komunikatu wtyczki jaka pojawi się po <strong>akceptacji</strong> rezerwacji:',
    messageAfterReservationReject: 'Treść komunikatu wtyczki jaka pojawi się po <strong>odrzuceniu</strong> rezerwacji:',
    messageForReservationWaitingForAccept: 'Treść komunikatu wtyczki jaka pojawi się w przypadku rezerwacji <strong>oczekującej na płatność</strong>:',
    messageAfterSucessfulSendingForm: 'Treść komunikatu wtyczki jaka pojawi się po poprawnym wysłaniu formularza rezerwacji:',
    messageDanger: 'Bardzo ważny komunikat',
    messageInfo: 'Informacja',
    messageStyle: 'Styl komunikatu:',
    messageWarning: 'Ostrzeżenie',
    messageWaitingList: 'Treść komunikaty wtyczki, gdy <strong>dopisujemy do listy rezerwowej</strong>:',
    messageWillAppearInsteadOfForm: 'Treść komunikatu wtyczki jaka pojawi się zamiast formularza:',
    messageWillAppearOverForm: 'Treść komunikatu wtyczki jaka pojawi nad formularzem:',
    msgConfirmed: 'Dziękujemy za wybranie terminu.',
    msgDenied: 'Odrzucenie rezerwacji. Brak miejsc w tym terminie.',
    msgSent: 'Dziękujemy za wysłanie zapytania. Nie zamykaj formularza i oczekuj na odpowiedź bądź sprawdź swoją skrzynkę mailową.',
    msgWaitingList: 'Twoja rezerwacja została dodana do listy rezerwowej.',
    no: 'Nie',
    resetDateAndTime: 'Resetuj wszystko',
    resetOnlyTime: 'Resetuj tylko godzinę',
    resetTermAfterAddToCart: 'Resetowanie wybranego terminu po dodaniu do koszyka',
    selectFirstService: 'Zaznaczaj domyślnie pierwszą usługę',
    settingsSaved: 'Ustawienia wtyczki zostały zmienione',
    showAllHours: 'Wszystkie',
    showAvailableHours: 'Wyświetlaj dostępne godziny:',
    showOnlyFirstAvailableHour: 'Tylko pierwszą z dostępnych',
    showPriceBeforeAddToCart: 'Pokazuj cenę przed przejściem do podsumowania',
    showPriceBeforeAddToCartDesc: 'Włączenie tej opcji, spowoduje pokazywanie i aktualizowanie ceny na bazie wyborów użytkownika w pierwszym kroku składania rezerwacji',
    showPrices: 'Pokazuj ceny:',
    showPricesInSummary: 'Pokazuj w podsumowaniu',
    showPricesOnServicesList: 'Pokazuj na liście usług',
    showPricesOnServicesListAndSummary: 'Pokazuj na liście usług oraz w podsumowaniu',
    showWorkersDetails: 'Pokazuj opisy pracowników',
    title: 'Ustawienia wtyczki',
    twoStepServiceChoice: 'Dwuetapowy wybór usługi',
    useFB: 'Zbieraj dane poprzez Piksel Facebooka',
    useGA: 'Zbieraj dane poprzez Google Analytics 4',
    useStyledDropdowns: 'Używaj ostylowanych list wyboru',
    warning: 'Uwaga!'
  },
  settingsReservations: {
    additionalReservationsFeaturesTitle: 'Dodatkowe funkcje związane z rezerwacjami',
    additionalReservationsRulesTitle: 'Dodatkowe reguły dodawania rezerwacji',
    allowFutureReservationsAtMax: 'Pozwalaj na rezerwacje maksymalnie:',
    allowReservationCancellationAtMax: 'Pozwalaj na anulowanie rezerwacji maksymalnie:',
    allowWorkerSelect: 'Pozwól wybierać pracownika:',
    autoAttendances: 'Automatyczne zaznaczanie obecności:',
    autoWaitingList: 'Automatycznie wysyłaj powiadomienia o wolnym terminie:',
    configureReservationsTitle: 'Konfiguruj sposób dodawania rezerwacji przez klientów',
    customersBasedOn: 'Twórz nowych klientów na podstawie:',
    days5: '5 dni',
    days7: '7 dni',
    days10: '10 dni',
    days14: '14 dni',
    daysForward: 'dni do przodu',
    doNotAllowMoreThanOneReservationForTheSameTermAddedByOneUser: 'Blokuj rezerwacje na tę samą godzinę dodane przez tego jednego użytkownika:',
    doNotManageCustomers: 'nie zarządzaj klientami',
    emailAddress: 'adresu e-mail',
    enableDiscountCodes: 'Włącz kody rabatowe:',
    enableAttendancesList: 'Włącz listę obecności:',
    enableWaitingList: 'Włącz listę rezerwową:',
    hidePhoneField: 'Ukryj pole do wpisania numeru telefonu:',
    hoursBefore: 'godzin przed',
    hours1: '1 godz. 0 min.',
    hours1minutes5: '1 godz. 5 min.',
    hours1minutes10: '1 godz. 10 min.',
    hours1minutes15: '1 godz. 15 min.',
    hours1minutes20: '1 godz. 20 min.',
    hours1minutes25: '1 godz. 25 min.',
    hours1minutes30: '1 godz. 30 min.',
    hours1minutes35: '1 godz. 35 min.',
    hours1minutes40: '1 godz. 40 min.',
    hours1minutes45: '1 godz. 45 min.',
    hours1minutes50: '1 godz. 50 min.',
    hours1minutes55: '1 godz. 55 min.',
    hours2: '2 godz. 0 min.',
    hours2minutes30: '2 godz. 30 min.',
    hours3: '3 godz.',
    hours3minutes30: '3 godz. 30 min.',
    hours4: '4 godz.',
    hours4minutes30: '4 godz. 30 min.',
    hours5: '5 godz.',
    hours5minutes30: '5 godz. 30 min.',
    hours6: '6 godz.',
    hours12: '12 godz.',
    hours24: '24 godz.',
    hours48: '48 godz.',
    hours72: '72 godz.',
    minutes15: '15 min.',
    minutes20: '20 min.',
    minutes25: '25 min.',
    minutes30: '30 min.',
    minutes35: '35 min.',
    minutes40: '40 min.',
    minutes45: '45 min.',
    minutes50: '50 min.',
    minutes55: '55 min.',
    nextDay: 'Następnego dnia',
    periodicity: 'Cykliczność i pakiety rezerwacji:',
    phoneNumber: 'numeru telefonu',
    phonePrefix: 'Domyślny kraj dla numeru telefonu',
    phonePrefixDesc: 'Kod kraju np. "pl", "de", "gb"',
    reservationsDistance: 'Rezerwacje z wyprzedzeniem:',
    reservationSettingsSaved: 'Ustawienia rezerwacji zostały zmienione',
    requireEmail: 'Wymagaj wpisania adresu e-mail:',
    requirePeopleNumber: 'Wymagaj podania liczby osób:',
    requirePhone: 'Wymagaj wpisania numeru telefonu:',
    services: 'Usług',
    servicesLabel: 'Etykieta dla listy usług:',
    syncAvailableHoursAccordingToAvailability: 'Zaczynaj dostępne godziny względem dostępności:',
    syncHoursDescription: 'Wybierz względem jakiego harmonogramu chcesz pokazywać terminarz. Jeżeli zaznaczysz "Pracownik" pierwsza dostępna godzina będzie równa godzinie rozpoczęcia pracy wybranego pracownika. Jeśli zaznaczysz "Usługa", terminarz będzie się zaczynał od pierwszej dostępnej godziny dla wybranej usługi.',
    textDisplayedWhenCannotCancel: 'Tekst wyświetlany gdy nie można już anulować rezerwacji:',
    thisOptionRequiresServicesAndPaymentsEnabled: 'Ta opcja jest dostępna gdy usługi i płatności są włączone',
    timeSpaces: 'Odstępy czasu przy wyborze godziny rezerwacji:',
    timeSpacesTheSameAsServiceDuration: 'Odstępy takie jak czas trwania usługi',
    title: 'Ustawienia rezerwacji',
    workers: 'Pracowników',
    youCannotDisableThisOptionIfCustomersAreBasedOnEmail: 'Tej opcji nie można wyłączyć jeśli wybrano tworzenie nowych klientów na podstawie adresu e-mail',
    youCannotDisableThisOptionIfCustomersAreBasedOnPhone: 'Tej opcji nie można wyłączyć jeśli wybrano tworzenie nowych klientów na podstawie numeru telefonu',
    zeroMeansNoLimits: '0 oznacza brak ograniczeń'
  },
  settingsSms: {
    betweenNightHours: 'Pomiędzy godziną 22:00 a 6:00',
    cancelReservationBySms: 'Anulowanie rezerwacji przez SMS:',
    cancellationIsTriggeredBySmsResponse: 'Anulowanie rezerwacji odbywa sie przez odpisanie na SMS przypominający',
    okUnderstand: 'OK, rozumiem',
    sendReminderBeforeReservation: 'Wyślij przypomnienie przed rezerwacją:',
    smsAbroadNotice: 'W przypadku włączenia opcji, koszt SMS będzie wynosił 21gr netto',
    smsCancellationTemplate: 'Anulowano! {data} {godzina} {usluga}',
    smsCancelNotice: 'Koszt SMS na numer zagraniczny wynosi 21gr netto',
    smsCantCancelTemplate: 'Nie można anulować rezerwacji: {data} {godzina} {usluga}',
    smsContent: 'Treść przypomnienia SMS:',
    smsContentForCancelledReservation: 'Treść SMS jaką otrzyma klient gdy anuluje rezerwację przy pomocy SMS:',
    smsContentForCantCancelReservation: 'Treść SMS jaką otrzyma klient gdy nie można już anulować rezerwacji przy pomocy SMS:',
    smsContentTitle: 'Treść wiadomości SMS',
    smsNotificationTemplate: 'Przypominamy! {data} {godzina} {usluga}',
    smsSendingSettings: 'Ustawienia wysyłki wiadomości SMS',
    smsSent: 'SMS został wysłany',
    smsSettingsChanged: 'Ustawienia SMS zostały zmienione',
    smsTextToCancel: 'Tekst SMS anulujący rezerwację',
    smsTextToCancelDesc: 'Pozostaw to pole pustym aby SMS o dowolnej treści anulował rezerwację',
    submitSmsAbroad: 'Wysyłaj SMS na numery zagraniczne',
    submitSmsAtNight: 'Wysyłaj przypomnienia także w nocy:',
    submitTestSmsTo: 'Wyślij testowy SMS na nr:',
    submitTestSms: 'Wyślij SMS testowy',
    title: 'Ustawienia powiadomień SMS',
    unableToSendSms: 'Nie udalo się wysłać wiadomości SMS',
    warning: 'Uwaga!',
    warningSmsContentText: 'Kliknij tutaj i dowiedz się jak treść Twoich powiadomień może wpływać na ilość wiadomości SMS potrzebnych do wysłania powiadomienia.'
  },
  settingsWww: {
    analyticsIntegrationsTitle: 'Integracje z usługami analitycznymi',
    configureTitle: 'Konfiguruj swoją stronę WWW',
    facebook: 'Facebook:',
    facebookPixelID: 'Meta Pixel ID:',
    facebookPixelIDdesc: 'Dawniej Facebook Pixel. <a href="https://www.facebook.com/business/help/171689010314963" target="_blank" rel="noopener noreferrer nofollow">Zobacz jak znaleźć Meta Pixel ID</a>',
    googleAnalyticsID: 'Google Analytics 4 tag ID:',
    googleAnalyticsIDdesc: 'Zobacz <a href="https://support.google.com/analytics/answer/9539598?hl=pl" target="_blank" rel="noopener noreferrer nofollow">jak znaleźć tag ID</a> w Google Analytics 4.',
    instagram: 'Instagram:',
    linkedin: 'LinkedIn:',
    menuHide: 'Nie wyświetlaj',
    menuLogoCenter: 'Menu z logo wyśrodkowanym',
    menuLogoLeft: 'Menu z logo po lewej stronie',
    pinterest: 'Pinterest:',
    pleaseProvideUrl: 'Proszę podać adres strony',
    primaryColor: 'Kolor podstawowy:',
    rememberAboutPluginTracking: 'Pamiętaj, aby skonfigurować odpowiednio zbieranie danych we wtyczce do składania rezerwacji.',
    secondaryColor: 'Kolor dodatkowy:',
    showMenu: 'Pokazuj menu:',
    showPhone: 'Pokaż numer telefonu:',
    showSocialMediaIcons: 'Pokaż ikony social media:',
    socialMediaLinks: 'Linki do serwisów społecznościowych',
    submitNewFileToChangeFavicon: 'Wyślij nowy plik by zmienić faviconę',
    title: 'Ustawienia strony WWW',
    tripAdvisor: 'TripAdvisor:',
    twitter: 'X (dawny Twitter):',
    urlIsUnavailable: 'Podana nazwa domeny jest już zajęta. Proszę wybrać inny adres.',
    websiteDescription: 'Streszczenie strony:',
    websiteDomain: '.bookero.pl',
    websiteFavicon: 'Favicon:',
    websiteKeywords: 'Słowa kluczowe:',
    websiteName: 'Nazwa strony:',
    websiteSettingsSaved: 'Ustawienia strony WWW zostały zmienione',
    websiteUrl: 'Adres strony:',
    youtube: 'YouTube:'
  },
  sidebar: {
    attendances: 'Lista obecności',
    blockedTermins: 'Lista blokad',
    billing: 'Rozliczenia',
    calendar: 'Kalendarz',
    clients: 'Klienci',
    company: 'Dane firmy',
    config: 'Konfiguracja',
    day: ' dzień',
    days: ' dni',
    discounts: 'Kody rabatowe',
    history: 'Historia rezerwacji',
    home: 'Mój panel',
    integrations: 'Integracje',
    invoices: 'Dokumenty sprzedażowe',
    myPage: 'Twoja strona',
    openingRules: 'Reguły otwarcia',
    payments: 'Historia płatności',
    priceRules: 'Reguły cen',
    rules: 'Reguły',
    reservationParams: 'Parametry rezerwacji',
    reservationRules: 'Reguły rezerwacji',
    services: 'Usługi',
    settings: 'Ustawienia',
    smsHistory: 'Historia SMS',
    stats: 'Statystyki',
    surveys: 'Ankiety',
    surveysFilled: 'Wypełnione ankiety',
    waitingList: 'Lista rezerwowa',
    workers: 'Pracownicy',
    yourCompany: 'Twoja firma',
    yourPackageExpiresIn: 'Twój pakiet wygasa za ',
    yourProfile: 'Twój profil',
    yourReservations: 'Twoje rezerwacje'
  },
  smsHistory: {
    details: 'Szczegóły',
    message: 'Wiadomość',
    noMessages: 'Nie znaleziono żadnych wiadomości SMS...',
    noMessagesForGivenFilters: 'Nie znaleziono żadnych wiadomości SMS spełniających podane kryteria...',
    receiver: 'Odbiorca',
    reservation: 'Rezerwacja',
    sendTime: 'Czas wysyłki',
    smsCount: 'Liczba SMS',
    smsType: 'Rodzaj SMS',
    title: 'Historia SMS'
  },
  smsHistoryListItem: {
    count: 'Ilość wiadomości:',
    message: 'Treść wiadomości:',
    receiver: 'Odbiorca:',
    reservation: 'Rezerwacja #{inquiryID}',
    sent: 'Wysłano:',
    sms: 'SMS',
    type: 'Typ wiadomości:',
    typeCancel: 'Wiadomość po anulowaniu rezerwacji',
    typeNotification: 'Powiadomienie'
  },
  splashscreen: {
    loadingText: 'Trwa ładowanie danych...'
  },
  statistics: {
    accepted: 'Zaakceptowane',
    cancelled: 'Anulowane',
    dateRanges: {
      last7days: 'Ostatnie 7 dni',
      last30days: 'Ostatnie 30 dni',
      last90days: 'Ostatnie 90 dni',
      last180days: 'Ostatnie 180 dni',
      last365days: 'Ostatnie 365 dni',
      thisWeek: 'Ten tydzień',
      thisMonth: 'Ten miesiąc',
      thisQuarter: 'Ten kwartał',
      thisYear: 'Ten rok',
      previousWeek: 'Poprzedni tydzień',
      previousMonth: 'Poprzedni miesiąc',
      previousQuarter: 'Poprzedni kwartał',
      previousYear: 'Poprzedni rok',
      custom: 'Własny okres'
    },
    dateTypeCreated: 'Wyświetlaj według daty utworzenia rezerwacji',
    dateTypeReservationDate: 'Wyświetlaj według daty na którą jest rezerwacja',
    income: 'Dochód',
    rejected: 'Odrzucone',
    showLess: 'Pokaż mniej',
    showMore: 'Pokaż więcej',
    title: 'Statystyki',
    titles: {
      common: 'Ogólne',
      selectedService: 'Dla wybranej usługi',
      selectedWorker: 'Dla wybranego pracownika',
      services: 'Usługi',
      servicesByIncome: 'Według kwoty przychodu',
      servicesByAccepted: 'Według liczby zaakceptowanych rezerwacji',
      workers: 'Pracownicy',
      workersByIncome: 'Według kwoty przychodu',
      workersByAccepted: 'Według liczby zaakceptowanych rezerwcji'
    },
    total: 'Wszystkie'
  },
  stats: {
    accepted: 'Zaakceptowane',
    allTotal: 'Razem wszystkich',
    cancelled: 'Anulowane',
    change: 'Zmiana',
    hideStats: 'Schowaj statystyki',
    newClients: 'Nowi klienci',
    percentTotal: 'Procent całości',
    reservations: 'Rezerwacje',
    showStats: 'Pokaż statystyki',
    trade: 'Obrót'
  },
  statsChart: {
    accepted: 'Zaakceptowane',
    all: 'Wszystkie',
    cancelled: 'Anulowane',
    confirmed: 'Potwierdzone',
    income: 'Dochód',
    rejected: 'Odrzucone',
    reservations: 'Rezerwacje',
    title: 'Wykres rezerwacji'
  },
  surveys: {
    addNew: 'Nowa ankieta',
    name: 'Nazwa',
    noSurveys: 'Brak ankiet...',
    noSurveysForGivenFilters: 'Brak ankiet spełniających podane kryteria wyszukiwania...',
    services: 'Usługi',
    systemName: 'Opis ankiety',
    thisSurveyIsNotPublished: 'Ta ankieta nie jest opublikowana',
    title: 'Ankiety'
  },
  surveysFilled: {
    allSurveys: 'Wszystkie ankiety',
    date: 'Data',
    export: 'Eksportuj',
    filePrefix: 'Ankieta',
    inquiry: 'Powiązana rezerwacja',
    scoring: 'Ocena',
    surveyName: 'Nazwa ankiety',
    title: 'Wypełnione ankiety'
  },
  surveyFilledListItem: {
    reservation: 'Zobacz rezerwację',
    seeSurvey: 'Zobacz odpowiedzi'
  },
  surveyForm: {
    addAnswer: 'Dodaj odpowiedź',
    addTitle: 'Dodaj ankietę',
    addQuestion: 'Dodaj pytanie',
    answerScoring: 'Ocena',
    answerText: 'Treść odpowiedzi',
    attendance: 'Obecność klienta',
    availableAnswers: 'Dostępne odpowiedzi',
    closedQuestion: 'Pytanie zamknięte',
    configurationTitle: 'Konfiguracja ankiet',
    editTitle: 'Edytuj ankietę',
    emptyStateForAnswers: 'Brak odpowiedzi',
    emptyStateForQuestions: 'Brak pytań',
    hiddenSurveysAreVisibleOnlyInAdminPanel: 'Ukryte ankiety są widoczne tylko w panelu administracyjnym',
    hideSurvey: 'Ukryj ankietę',
    hoursToSend: 'Na ile godzin przed / po rezerwacji wysłać ankietę?',
    name: 'Nazwa',
    openQuestion: 'Pytanie zamknięte?',
    removeAnswer: 'Usuń odpowiedź',
    removeQuestion: 'Usuń pytanie',
    requiredQuestion: 'Odpowiedź wymagana',
    surveyAdded: 'Ankieta została dodana',
    surveyChanged: 'Ankieta została zmieniona',
    question: 'Pytanie',
    questionIsRequired: 'Odpowiedź wymagana?',
    questionsTitle: 'Treść ankiety',
    sendOnce: 'Jak wysyłać ankietę?',
    sendOnceOptionOnce: 'Tylko raz - nie powtarzaj przy nowych rezerwacjach',
    sendOnceOptionEverytime: 'Wyślij za każdym razem',
    sendType: 'Kiedy wysyłać ankietę?',
    sendTypeOptionAfter: 'Po odbytej rezerwacji',
    sendTypeOptionBefore: 'Przed odbytą rezerwacją',
    sendTypeOptionAfterSave: 'Po dodaniu rezerwacji do systemu',
    servicesTitle: 'Ogranicz wysyłkę do zaznaczonych usług',
    servicesDesc: 'Jeśli nie zaznaczysz żadnej usługi, ankieta będzie działać w ramach wszystkich usług',
    skipAttendance: 'Nie uwzględniaj obecności',
    systemName: 'Opis ankiety',
    textThankYou: 'Tekst, który pojawi się po wypełnieniu ankiety',
    textToEmail: 'Tekst załączany do e-maila z prośbą o wypełnienie ankiety',
    textToSurvey: 'Tekst wprowadzający wyświetlany na stronie wypełniania ankiety',
    whenUserNotPresent: 'Gdy klient nie pojawił się',
    whenUserPresent: 'Gdy klient pojawił się'
  },
  surveysListItem: {
    editSurvey: 'Edytuj ankietę',
    hideSurvey: 'Ukryj ankietę',
    publishSurvey: 'Opublikuj ankietę',
    previewSurvey: 'Otwórz podgląd',
    removeSurvey: 'Usuń ankietę',
    removingSurveyTitle: 'Usuwanie ankiety',
    removingSurveyDesc: 'Czy na pewno chcesz usunąć wybraną ankietę?',
    removingSurveyBtn: 'Usuń ankietę',
    selectedSurveyHasBeenRemoved: 'Wybrana ankieta została usunięta',
    selectedSurveyPublished: 'Wybrana ankieta została opublikowana',
    selectedSurveyUnpublished: 'Wybrana ankieta została ukryta'
  },
  surveyPreviewPopup: {
    loadError: 'Wystąpił błąd podczas wczytywania danych podglądu',
    openLink: 'Otwórz podgląd w nowej karcie',
    title: 'Podgląd ankiety'
  },
  surveyResultsPopup: {
    score: 'Ocena',
    title: 'Odpowiedzi w ankiecie'
  },
  topBar: {
    attendances: 'Lista obecności',
    blockedTermins: 'Lista blokad',
    billing: 'Rozliczenia',
    calendar: 'Kalendarz',
    checkNews: 'Nowe funkcje!',
    clients: 'Klienci',
    checkTerm: 'Szukaj wolnego terminu',
    cookieSettings: 'Ustawienia cookies',
    companyData: 'Dane firmy',
    disableReservations: 'Wyłącz rezerwacje',
    disableReservationsDesc: 'Czy na pewno chcesz wyłączyć możliwość dodawania rezerwacji na stronie?',
    disableReservationsTitle: 'Wyłączenie rezerwacji',
    discounts: 'Kody rabatowe',
    enableReservations: 'Włącz rezerwacje',
    help: 'Pomoc',
    history: 'Historia rezerwacji',
    integrations: 'Integracje',
    invoices: 'Dokumenty sprzedażowe',
    logout: 'Wyloguj',
    myPage: 'Twoja strona',
    new: 'Nowości',
    noInternetConnection: 'Brak połączenia internetowego.',
    openingRules: 'Reguły otwarcia',
    payments: 'Historia płatności',
    priceRules: 'Reguły cen',
    refreshApp: 'Odśwież',
    reservationsDisabled: 'Wyłączono możliwość dodawania rezerwacji na stronie',
    reservationsEnabled: 'Włączono możliwość dodawania rezerwacji na stronie',
    reservationParams: 'Parametry rezerwacji',
    reservationRules: 'Reguły rezerwacji',
    services: 'Usługi',
    settings: 'Ustawienia',
    smsHistory: 'Historia SMS',
    stats: 'Statystyki',
    surveys: 'Ankiety',
    surveysFilled: 'Wypełnione ankiety',
    updateAvailable: 'Dostępna jest zaktualizowana wersja Bookero - odśwież stronę aby uzyskać do niej dostep',
    waitingList: 'Lista rezerwowa',
    workers: 'Pracownicy',
    yourPanel: 'Twój panel',
    yourProfile: 'Twój profil'
  },
  topBarSearch: {
    placeholder: 'Szukaj rezerwacji...'
  },
  waitingList: {
    actions: 'Akcje',
    additionalInformations: 'Dodatkowe informacje',
    client: 'Rezerwujący',
    date: 'Data',
    exportAs: 'Eksportuj jako ',
    filePrefix: 'lista-rezerwowa.',
    noReservations: 'Nie znaleziono żadnych rezerwacji...',
    noReservationsForGivenFilters: 'Nie znaleziono żadnych rezerwacji spełniających podane kryteria...',
    service: 'Usługa',
    status: 'Status rezerwacji',
    title: 'Lista rezerwowa'
  },
  waitingListItem: {
    call: 'Zadzwoń',
    cardRegistered: 'Karta zarejestrowana',
    category: 'Kategoria: ',
    formSent: 'Formularz wysłano:',
    notificationDate: 'Powiadomienie o zwolnieniu terminu:',
    notificationNotSend: 'Nie udało się wysłać powiadomienia',
    notificationSend: 'Powiadomienie o wolnym terminie zostało wysłane',
    paid: 'Zapłacone',
    reservationDetails: 'Szczegóły rezerwacji #{id}',
    reservationParentDetails: 'Rezerwacja główna #{id}',
    seeMore: 'Zobacz więcej',
    sendEmail: 'Wyślij e-mail',
    sendNotification: 'Powiadom',
    unPaid: 'Niezapłacone'
  },
  workers: {
    addWorker: 'Dodaj pracownika',
    email: 'Email',
    emailNotifications: 'Powiadomienia e-mail',
    googleCalendarIntegration: 'Integracja z Google Calendar',
    maxWorkersUsed: 'Obecnie wykorzystujesz maksymalną liczbę pracowników w swoim planie ({maxWorkers} pracowników).',
    name: 'Imię i nazwisko',
    noWorkers: 'Nie znaleziono żadnych pracowników...',
    noWorkersForTheGivenCriteria: 'Brak pracowników spełniających podane kryteria...',
    outlookCalendarIntegration: 'Integracja z Outlook Calendar',
    searchForWorkers: 'Wyszukaj pracowników...',
    services: 'Usługi',
    title: 'Pracownicy'
  },
  workerForm: {
    avatar: 'Avatar:',
    avatarColor: 'Kolor avatara:',
    calendar: 'Kalendarz:',
    confirmPassword: 'Potwierdź hasło:',
    connectedGoogleAccount: 'Powiązane konto Google',
    connectedOutlookAccount: 'Powiązane konto Outlook',
    fillThisFieldToChangePassword: 'Wypełnij to pole, jeśli chcesz zmienić hasło',
    initials: 'Inicjały:',
    initialsDescription: 'Maksymalnie 2 znaki. To pole uzupełni się automatycznie, jeśli pozostawisz je pustym.',
    name: 'Imię i nazwisko:',
    password: 'Hasło:',
    providedPasswordsAreNotTheSame: 'Podane hasła nie są identyczne',
    removeAvatar: 'Usuń avatar',
    removeConnectedAccount: 'Usuń powiązanie z tym kontem',
    selectCalendar: 'Wybierz kalendarz',
    settingsTitle: 'Ustawienia',
    submitNewFileToChangeAvatar: 'Wyślij nowy plik by zmienić avatar',
    yourData: 'Twoje dane',
    yourDataHasBeenChanged: 'Twoje dane zostały zmienione',
    yourProfile: 'Twój profil',
    workHoursTitle: 'Godziny pracy'
  },
  workersForm: {
    addTitle: 'Dodawanie pracownika',
    avatar: 'Avatar:',
    avatarColor: 'Kolor avatara:',
    calendar: 'Kalendarz:',
    canChangePaymentStatus: 'Może zmieniać status płatności:',
    canManageExceptions: 'Może zarządzać regułami otwarcia firmy:',
    canManageOwnReservations: 'Może zarządzać swoimi rezerwacjami:',
    canManageOwnWorkHours: 'Może zarządzać swoim grafikiem:',
    canManageReservations: 'Może zarządzać rezerwacjami:',
    canManageWorkerExceptions: 'Może zarządzać regułami pracy pracowników:',
    canManageWorkerExceptionsCannot: 'nie może',
    canManageWorkerExceptionsOnlyOwn: 'może tylko swoimi',
    canManageWorkerExceptionsAll: 'może wszystkimi',
    canSeePayments: 'Ma wgląd w płatności',
    canSeePaymentsOnlyForReservations: 'Wgląd w płatności tylko dla pojedynczych rezerwacji',
    confirmPassword: 'Potwierdź hasło:',
    connectedAccount: 'Powiązane konto',
    description: 'Opis:',
    disableWorker: 'Wyłącz pracownika:',
    disableWorkerDescription: 'Wyłączony pracownik będzie widoczny tylko w panelu administracyjnym.<br>Pracownik nie będzie brany pod uwagę przy wyszukiwaniu dostępnych terminów.',
    editTitle: 'Edycja pracownika',
    email: 'E-mail:',
    emailNotification: 'Powiadomienia e-mail:',
    fillThisFieldToChangePassword: 'Wypełnij to pole, jeśli chcesz zmienić hasło',
    googleCalendarIntegration: 'Integracja z Google Calendar:',
    limitOfReservationsPerTerm: 'Limit rezerwacji na termin:',
    initials: 'Inicjały:',
    initialsDescription: 'Maksymalnie 2 znaki. To pole uzupełni się automatycznie, jeśli pozostawisz je pustym.',
    integrationWithOutlookCalendar: 'Integracja z Outlook Calendar:',
    name: 'Imię i nazwisko:',
    openingHoursTitle: 'Reguły godzin pracy',
    password: 'Hasło:',
    providedPasswordsAreNotTheSame: 'Podane hasła nie są identyczne',
    reception: 'Recepcja',
    removeAvatar: 'Usuń avatar',
    removeConnectedAccount: 'Usuń powiązanie z tym kontem',
    selectCalendar: 'Wybierz kalendarz',
    servicesTitle: 'Usługi',
    settingsTitle: 'Ustawienia',
    submitNewFileToChangeAvatar: 'Wyślij nowy plik by zmienić avatar',
    userData: 'Dane użytkownika',
    userType: 'Rodzaj użytkownika:',
    worker: 'Pracownik firmy',
    workerAdded: 'Pracownik został dodany',
    workerDataChanged: 'Dane pracownika zostały zmienione',
    workHoursTitle: 'Godziny pracy',
    youMustProvidePasswordForWorker: 'Musisz podać hasło dla pracownika'
  },
  workersListItem: {
    accountType: 'Typ konta:',
    disableWorker: 'Wyłącz pracownika',
    editWorker: 'Edytuj pracownika',
    email: 'E-mail:',
    emailNotConfirmed: 'E-mail wymaga potwierdzenia',
    emailNotification: 'Powiadomienia e-mail:',
    enableWorker: 'Włącz pracownika',
    googleCalendarIntegration: 'Integracja z Google Calendar:',
    hide: 'Ukryj',
    hideWorker: 'Ukryj pracownika',
    no: 'Nie',
    noOutlookCalendarForThisWorker: 'Brak kalendarza Outlook przypisanego do tego pracownika.',
    noServicesForThisWorker: 'Brak usług przypisanych do tego pracownika.',
    notApplies: 'nie dotyczy',
    outlookCalendarIntegration: 'Integracja z Outlook Calendar:',
    publish: 'Opublikuj',
    publishWorker: 'Opublikuj pracownika',
    reception: 'recepcja',
    removeWorker: 'Usuń pracownika',
    removingWorkerTitle: 'Usuwanie pracownika',
    removingWorkerDesc: 'Czy na pewno chcesz usunąć wybranego pracownika?',
    removingWorkerBtn: 'Usuń pracownika',
    selectedWorkerHasBeenDisabled: 'Wybrany pracownik został wyłączony',
    selectedWorkerHasBeenEnabled: 'Wybrany pracownik został włączony',
    selectedWorkerHasBeenRemoved: 'Wybrany pracownik został usunięty',
    services: 'Usługi:',
    thisWorkerIsDisabled: 'Ten pracownik jest wyłączony',
    worker: 'pracownik',
    yes: 'Tak'
  }
};



// WEBPACK FOOTER //
// ./src/langs/pl.js